import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuid from 'uuid/v4';
import _ from 'lodash';
import GenericButton from '../common/GenericButton';
import GenericFileUpload from '../common/GenericFileUpload';
import GenericCheckboxesDropdown from '../common/GenericCheckboxesDropdown';
import * as CrosstabUtils from '../../util/CrosstabUtils';
import {
  makeTextFile,
  getExportStudyType,
  reformatSpcArray,
  checkWeightType,
  isFeaturePresent,
  isAllFeaturePresent,
  isStudyAccredited,
  exportFileTitle,
  getOffsetDate,
} from '../../util/CommonUtils';
import Modal from '../common/Modal/Modal';
import StudySelector from '../common/StudySelector';
import TrendMultiSelect from './Trend/TrendMultiSelect';
import ExportBaseMultiSelect from './ExportBase/ExportBaseMultiSelect';
import DraggableToolPaletteHeader from './DraggableToolPaletteHeader';
import ToolPaletteHeader from './ToolPaletteHeader';
import DraggableToolPaletteGrid from './DraggableToolPaletteGrid';
import SavedCrosstabs from './SavedCrosstabs';
import Highlight from '../common/HighlightAndFilter/Highlight';
import * as crosstabActions from '../../actions/crosstabActions';
import * as studyActions from '../../actions/studyActions';
import * as dictionaryActions from '../../actions/dictionaryActions';
import EditIcon from '../../images/edit-icon_l.png';
import * as quickReportsActions from '../../actions/quickReportsActions';
import { saveTrackingData, getActionName } from '../../util/trackerUtils';
import { sendVPVHotjarEvent } from '../../util/hotjarUtils';
import {
  getLabel,
  buildSPC2Object,
  checkSPCForVersion,
  rebuildGridObjectsFromNewSPC,
  rebuildAutocodeNodesForSPC,
} from '../../util/autocodeUtils';
import infoIconBlackOutline from '../../images/insight360/info-icon_black_outline.png';
import {
  TOOL_EXPORT_XLS,
  TOOL_OPEN_CROSSTAB,
  TOOL_IMPORT_SPC,
  TOOL_EXPORT_SPC,
  TOOL_EXPORT_CSV,
  TOOL_CHART_PRIVATE_EYE,
  TOOL_CHART_CROSSTAB,
  TOOL_CHART_QUAD,
  TOOL_CHART_TREND,
  TOOL_VIEW_HIGHLIGHT,
  TOOL_VIEW_SAMPLE,
  TOOL_VIEW_WEIGHTED,
  TOOL_VIEW_VERTICAL,
  TOOL_VIEW_HORIZONTAL,
  TOOL_VIEW_INDEX,
  TOOL_VIEW_CLEAR_ALL,
  ACTION_TYPE_TOOL_GRID,
  TOOL_BASE_CLEAR_ALL,
  TOOL_COLUMN_CLEAR_ALL,
  STUDY_UNIVERSE_LABEL,
  PREFERENCE_BASE_EXPORT_LIST,
  DATAHAUL_CONSTANT,
  CROSSTAB_CONSTANT,
  PREFERENCE_CROSSTAB,
  PREFERENCE_STUDY_SELECTOR_POPUP,
  PREFERENCE_BASE_EXPORT,
  PREFERENCE_STUDY_UNIVERSE,
  PREFERENCE_METRICS,
  FLEX_STUDY_TAG,
  CORRCLUSTER_FEATUREID,
  EXPORT_NAME_CONSTANT,
} from '../../constants';
import {
  HJ_CROSSTAB_HIGHLIGHTING_FILTERING,
  HJ_CROSSTAB_FULL_SHORT_LABEL_TOOGLE_MODE,
  HJ_CROSSTAB_CLEAR_ALL_ITEMS,
} from '../../hotjarConstants';
import {
  CROSSTAB_FULL_SHORT_LABEL_TOOGLE_MODE,
  CROSSTAB_CLEAR_ALL_ITEMS,
  CROSSTAB_CELL_HIGHLIGHT_FILTERING_OPEN,
} from '../../trackerConstants';
import { AC_PARTS_TO_SHOW } from '../autocode/AutocodeConstants';
import { SPC2, IPSOS_DISABLED_STUDY_LIST } from '../../actions/urlTypes';
import GlobalDelete from '../common/EnhancedGridFeature/GlobalDelete';
import ToggleLabel from '../common/EnhancedGridFeature/ToggleLabel';
import InfoBox, { InfoBoxSpacer } from '../common/EnhancedGridFeature/InfoBox';
import ToolPaletteEllipsisIcon from '../../images/menu-icon.png';
import corrCluster from '../../images/corrcluster/correspondence_icon.svg';
import SharedCrossTabList from './SharedCrossTabList';

const modalStyle = {
  width: 'auto',
  minWidth: '770px',
  maxWidth: '800px',
  height: 'auto',
  top: '5%',
  left: '24%',
};
const sharedModalStyle = {
  width: 'auto',
  minWidth: '550px',
  maxWidth: '550px',
  height: '450px',
  top: '5%',
  left: '24%',
};

const ModalQuadChartorHnFStyle = {
  minWidth: '850px',
  width: '60%',
  height: 'auto',
  left: '23%',
  top: '1%',
};

const afterOpenCrosstabModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const modalSavedCrosstabStyle = {
  width: '784px',
  height: '450px',
  left: '25%',
  top: '5%',
};

const trendModalStyle = {
  width: '55%',
  left: '20%',
  top: '3%',
};

const modalQuadWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};

const defaultColumnHeaderDef = {
  label: '',
  name: '',
  sortOrder: CrosstabUtils.SORT_DIRECTION.NONE,
  sortKey: '',
};

const defaultCount = {
  BasesDataGrid: 1,
  StandardBases: 1,
  ColumnsDataGrid: 5,
  DataHaulBasesDataGrid: 1,
  DataHaulColumnsDataGrid: 5,
  RowsDataGrid: 10,
};

class ToolPalette extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crosstabStudy: props.crosstabStudy,
      isViewScreenSelected: false,
      crosstabTitle: 'Untitled',
      selectedExportOption: 'excel2007',
      trendStudies: props.trendStudies || [],
      studies: props.studies ? props.studies : [],
      activeCrosstabTable: props.activeCrosstabTable
        ? props.activeCrosstabTable
        : {},
      checkBoxes:
        props.userPreference && props.userPreference[PREFERENCE_METRICS]
          ? {
              hnf: true,
              sample: props.userPreference[PREFERENCE_METRICS].includes(
                'sample'.toUpperCase()
              ),
              weighted: props.userPreference[PREFERENCE_METRICS].includes(
                'weighted'.toUpperCase()
              ),
              vertical: props.userPreference[PREFERENCE_METRICS].includes(
                'vertical'.toUpperCase()
              ),
              horizontal: props.userPreference[PREFERENCE_METRICS].includes(
                'horizontal'.toUpperCase()
              ),
              index: props.userPreference[PREFERENCE_METRICS].includes(
                'index'.toUpperCase()
              ),
            }
          : {
              hnf: true,
              sample: true,
              weighted: true,
              vertical: true,
              horizontal: true,
              index: true,
            },
      RowsDataGrid: props.rows || [],
      ColumnsDataGrid: props.columns || [],
      BasesDataGrid: props.bases || [],
      DataHaulBasesDataGrid: props.DataHaulBases || [],
      DataHaulColumnsDataGrid: props.DataHaulColumns || [],
      showMore: {
        BasesDataGrid: false,
        StandardBases: false,
        RowsDataGrid: false,
        ColumnsDataGrid: false,
        DataHaulBasesDataGrid: false,
        DataHaulColumnsDataGrid: false,
      },
      activeChartType:
        props.crosstabTableList && this.props.crosstabTableList.length > 0
          ? props.crosstabTableList[0].viewerGridType
          : CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE,
      shouldExportResult: false,
      selectedBase: props.selectedBase,
      userToggled: false,
      selectedOptions: {},
      isExportEnabled: false,
      showClusterCorrespondence: isFeaturePresent(
        CORRCLUSTER_FEATUREID,
        props.permissions
      ),
      sharedCrossTabId: 0,
      shareCrossTabModalFlag: false,
    };
  }

  componentDidMount() {
    if (
      this.props.userPreference &&
      this.props.userPreference[PREFERENCE_METRICS]
    ) {
      const updatedCheckboxes = Object.keys(this.state.checkBoxes).filter(
        elem => {
          if (
            elem !== 'hnf' &&
            this.props.userPreference &&
            !this.props.userPreference[PREFERENCE_METRICS].includes(
              elem.toUpperCase()
            )
          ) {
            return elem;
          }
        }
      );
      updatedCheckboxes.forEach(() => {
        const cellElementList = [
          ...CrosstabUtils.getDefaultCells(this.props.crosstabWeightTypes),
        ].map(cellElement => ({
          ...cellElement,
          isVisible: this.state.checkBoxes[cellElement.key],
        }));
        this.props.handleMetricsChange(cellElementList);
      });
    }
    if (
      this.props.studies &&
      this.props.standardBaseLists &&
      this.props.standardBaseLists.length === 0
    ) {
      const fetchStandardBasetParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.crosstabStudy.pn,
      };
      if (!this.props.loginResponse.data.universityUser) {
        this.props.crosstabActions.fetchStandardBaseList(
          fetchStandardBasetParams
        );
      }
    }
    this.getExportEnabled();
  }

  getExportEnabled() {
    if (
      this.props.crosstabStudy &&
      this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      if (
        this.props.crosstabBases &&
        this.props.crosstabBases.length > 0 &&
        ((this.props.crosstabColumns &&
          this.props.crosstabColumns.length > 0) ||
          (this.props.crosstabRows && this.props.crosstabRows.length > 0))
      ) {
        this.setState(() => ({ isExportEnabled: true }));
      } else {
        this.setState(() => ({ isExportEnabled: false }));
      }
    } else if (
      this.props.crosstabStudy &&
      !this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      if (
        (this.props.crosstabColumns && this.props.crosstabColumns.length > 0) ||
        (this.props.crosstabRows && this.props.crosstabRows.length > 0)
      ) {
        this.setState(() => ({ isExportEnabled: true }));
      } else {
        this.setState(() => ({ isExportEnabled: false }));
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.crosstabStudy &&
      this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      if (
        nextProps.crosstabBases &&
        nextProps.crosstabBases.length > 0 &&
        ((nextProps.crosstabColumns && nextProps.crosstabColumns.length > 0) ||
          (nextProps.crosstabRows && nextProps.crosstabRows.length > 0))
      ) {
        this.setState(() => ({ isExportEnabled: true }));
      } else {
        this.setState(() => ({ isExportEnabled: false }));
      }
    } else if (
      this.props.crosstabStudy &&
      !this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      if (
        (nextProps.crosstabColumns && nextProps.crosstabColumns.length > 0) ||
        (nextProps.crosstabRows && nextProps.crosstabRows.length > 0)
      ) {
        this.setState(() => ({ isExportEnabled: true }));
      } else {
        this.setState(() => ({ isExportEnabled: false }));
      }
    }
    if (this.props.crosstabTableList !== nextProps.crosstabTableList) {
      if (
        nextProps.crosstabTableList &&
        nextProps.crosstabTableList.length > 0
      ) {
        const activeCrosstabTable = nextProps.crosstabTableList.filter(
          crosstabTable => crosstabTable.isActive
        )[0];
        if (this.state.activeCrosstabTable === activeCrosstabTable) {
          // InActive entry deleted
          this.setState({ crosstabTableList: nextProps.crosstabTableList });
        } else {
          this.setState({
            crosstabTableList: nextProps.crosstabTableList,
            columnDefinitions: activeCrosstabTable.columnHeaderList.map(
              columnHeader => ({
                ...defaultColumnHeaderDef,
                ...columnHeader,
              })
            ),
            shouldExportResult: true,
            activeCrosstabTable,
          });
          this.props.crosstabActions.setActiveCrosstabTable(
            activeCrosstabTable
          );
        }
      } else {
        this.setState({
          crosstabTableList: [],
          activeCrosstabTable: {},
        });
      }
    }
    if (this.props.crosstabStudy !== nextProps.crosstabStudy) {
      this.setState({
        crosstabStudy: nextProps.crosstabStudy,
        shouldExportResult: false,
      });
    }
    if (this.props.trendStudies !== nextProps.trendStudies) {
      this.setState({ trendStudies: nextProps.trendStudies });
    }
    if (this.props.studies !== nextProps.studies && nextProps.studies) {
      this.setState({
        studies: nextProps.studies,
        shouldExportResult: false,
      });
      const fetchStandardBasetParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: nextProps.crosstabStudy.pn,
      };
      if (!this.props.loginResponse.data.universityUser) {
        this.props.crosstabActions.fetchStandardBaseList(
          fetchStandardBasetParams
        );
      }
    }
    if (this.props.crosstabWeightTypes !== nextProps.crosstabWeightTypes) {
      const cellElementList = [
        ...CrosstabUtils.getDefaultCells(nextProps.crosstabWeightTypes),
      ].map(cellElement => ({
        ...cellElement,
        isVisible: this.state.checkBoxes[cellElement.key],
      }));
      this.props.handleMetricsChange(cellElementList);
    }
    if (this.props.userPreference !== nextProps.userPreference) {
      const updatedCheckboxes = Object.keys(this.state.checkBoxes).filter(
        elem => {
          if (
            elem !== 'hnf' &&
            nextProps.userPreference &&
            !nextProps.userPreference[PREFERENCE_METRICS].includes(
              elem.toUpperCase()
            )
          ) {
            return elem;
          }
        }
      );
      const updatedMetrics = {
        ...this.state.checkBoxes,
        sample: nextProps.userPreference[PREFERENCE_METRICS].includes(
          'sample'.toUpperCase()
        ),
        weighted: nextProps.userPreference[PREFERENCE_METRICS].includes(
          'weighted'.toUpperCase()
        ),
        vertical: nextProps.userPreference[PREFERENCE_METRICS].includes(
          'vertical'.toUpperCase()
        ),
        horizontal: nextProps.userPreference[PREFERENCE_METRICS].includes(
          'horizontal'.toUpperCase()
        ),
        index: nextProps.userPreference[PREFERENCE_METRICS].includes(
          'index'.toUpperCase()
        ),
      };
      this.setState(
        () => ({ checkBoxes: updatedMetrics }),
        () => {
          updatedCheckboxes.forEach(() => {
            const cellElementList = [
              ...CrosstabUtils.getDefaultCells(nextProps.crosstabWeightTypes),
            ].map(cellElement => ({
              ...cellElement,
              isVisible: this.state.checkBoxes[cellElement.key],
            }));
            this.props.handleMetricsChange(cellElementList);
          });
        }
      );
    }
    if (nextProps.selectedBase !== this.props.selectedBase) {
      this.setState(() => ({ selectedBase: nextProps.selectedBase }));
    }
    if (
      (!_.isEqual(nextProps.rows, this.props.rows) && nextProps.rows) ||
      (!_.isEqual(nextProps.columns, this.props.columns) &&
        nextProps.columns) ||
      (!_.isEqual(nextProps.bases, this.props.bases) && nextProps.bases) ||
      (!_.isEqual(nextProps.DataHaulBases, this.props.DataHaulBases) &&
        nextProps.DataHaulBases) ||
      (!_.isEqual(nextProps.DataHaulColumns, this.props.DataHaulColumns) &&
        nextProps.DataHaulColumns)
    ) {
      if (this.toggle10) {
        this.toggle10.checked =
          (nextProps.rows && nextProps.rows.length > 0) ||
          (nextProps.columns && nextProps.columns.length > 0) ||
          (nextProps.bases && nextProps.bases.length > 0);
      }
      if (nextProps.rows !== this.props.rows && nextProps.rows) {
        if (this.toggle4) {
          this.toggle4.checked = nextProps.rows && nextProps.rows.length > 0;
        }
        this.setState({
          RowsDataGrid: nextProps.rows,
          shouldExportResult: false,
        });
      }
      if (nextProps.columns !== this.props.columns && nextProps.columns) {
        if (this.toggle3) {
          this.toggle3.checked =
            nextProps.columns && nextProps.columns.length > 0;
        }
        this.setState({
          ColumnsDataGrid: nextProps.columns,
          shouldExportResult: false,
        });
      }
      if (nextProps.bases !== this.props.bases && nextProps.bases) {
        if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
          this.toggle2.checked = nextProps.bases && nextProps.bases.length > 0;
          this.setState({
            BasesDataGrid: nextProps.bases,
            shouldExportResult: false,
          });
          this.state.userToggled = false;
          if (nextProps.bases.length > 0 && this.state.userToggled === false) {
            let existingNodeFlag = false;
            nextProps.bases.map(node => {
              if (
                nextProps.selectedBaseNode === node.keyword &&
                nextProps.selectedBaseGroup === 'user-defined'
              ) {
                existingNodeFlag = true;
                this.props.crosstabActions.setSelectedBase(
                  node.id,
                  node.keyword,
                  'user-defined'
                );
              }
              return null;
            });

            if (!existingNodeFlag) {
              if (
                nextProps.bases &&
                this.props.bases &&
                nextProps.bases.length > 0 &&
                this.props.bases.length === 0
              ) {
                this.props.crosstabActions.setSelectedBase(
                  nextProps.bases[0].id,
                  nextProps.bases[0].keyword,
                  'user-defined'
                );
              } else if (
                nextProps.selectedBase ===
                CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE
              ) {
                this.props.crosstabActions.setSelectedBase(
                  CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
                  CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
                  CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE
                );
              } else if (nextProps.standardBaseLists.length > 0) {
                let existingSelectedStandardBase = false;

                nextProps.standardBaseLists.map(element => {
                  if (
                    nextProps.selectedBaseNode === element.expression &&
                    nextProps.selectedBaseGroup === 'standard-base'
                  ) {
                    existingSelectedStandardBase = true;
                    this.props.crosstabActions.setSelectedBase(
                      element.expression,
                      element.expression,
                      'standard-base'
                    );
                  }
                  return null;
                });
                if (!existingSelectedStandardBase) {
                  this.props.crosstabActions.setSelectedBase(
                    nextProps.bases[0].id,
                    nextProps.bases[0].keyword,
                    'user-defined'
                  );
                }
              } else {
                this.props.crosstabActions.setSelectedBase(
                  nextProps.bases[0].id,
                  nextProps.bases[0].keyword,
                  'user-defined'
                );
              }
            }
          } else if (nextProps.bases.length === 0) {
            this.props.crosstabActions.setSelectedBase(
              CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
              CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
              CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE
            );
          }
        }
      } else if (nextProps.selectedBase === undefined) {
        this.props.crosstabActions.setSelectedBase(
          CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
          CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
          CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE
        );
      }
      if (
        nextProps.DataHaulBases !== this.props.DataHaulBases &&
        nextProps.DataHaulBases
      ) {
        if (this.toggle10) {
          this.toggle10.checked =
            nextProps.DataHaulBases && nextProps.DataHaulBases.length > 0;
        }
        if (this.toggle12) {
          this.toggle12.checked =
            nextProps.DataHaulBases && nextProps.DataHaulBases.length > 0;
        }
        this.setState({
          DataHaulBasesDataGrid: nextProps.DataHaulBases,
          shouldExportResult: false,
        });
        this.state.userToggled = false;
        if (
          nextProps.DataHaulBases.length > 0 &&
          this.state.userToggled === false
        ) {
          // this.state.selectedBase = nextProps.DataHaulBases[0].id;
        }
      }
      if (
        nextProps.DataHaulColumns !== this.props.DataHaulColumns &&
        nextProps.DataHaulColumns
      ) {
        if (this.toggle10) {
          this.toggle10.checked =
            nextProps.DataHaulColumns && nextProps.DataHaulColumns.length > 0;
        }
        if (this.toggle13) {
          this.toggle13.checked =
            nextProps.DataHaulColumns && nextProps.DataHaulColumns.length > 0;
        }
        this.setState({
          DataHaulColumnsDataGrid: nextProps.DataHaulColumns,
          shouldExportResult: false,
        });
      }
    }
    if (this.props.savedCrosstabs !== nextProps.savedCrosstabs) {
      this.setState({ savedCrosstabs: nextProps.savedCrosstabs });
      this.savedCrosstabsModal.show();
    }

    if (
      this.props.standardBaseLists !== nextProps.standardBaseLists &&
      nextProps.standardBaseLists.length > 0
    ) {
      const baseExpressionList = [];
      const selectedNamesList = [];
      nextProps.standardBaseLists.map(element => {
        baseExpressionList.push(element.expression);
        selectedNamesList.push(element.label);
        return null;
      });
      const sampleWeightedParams = {
        targetGrid: 'StandardBasesDataGrid',
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.state.crosstabStudy.pn,
        weightType: this.props.crosstabWeightTypes.wt,
        divisor: this.props.crosstabWeightTypes.dv,
        gridData: undefined,
        expressionList: [...baseExpressionList],
        selectedNames: [...selectedNamesList],
        originalNames: [...selectedNamesList],
        sourceGrid: 'StandardBasesDataGrid',
      };
      this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
    }
    if (
      nextProps.cbCrosstabRunType &&
      this.state.activeChartType !== nextProps.cbCrosstabRunType
    ) {
      let runType = nextProps.cbCrosstabRunType;
      if (nextProps.cbCrosstabRunType === 'Crosstab') {
        runType = 'Crosstab View';
      } else if (nextProps.cbCrosstabRunType === 'Private Eye') {
        runType = 'Private Eye View';
      }
      this.setState({ activeChartType: runType });
    }

    if (
      this.props.crosstabStudy &&
      nextProps.loadNewSPCCrosstabData &&
      this.props.loadNewSPCCrosstabData !== nextProps.loadNewSPCCrosstabData
    ) {
      const spcObject = _.cloneDeep(nextProps.loadNewSPCCrosstabData);

      const newSpcStructureParams = rebuildGridObjectsFromNewSPC({
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        spcObject,
        partsToShow: this.props.partsToShow,
        productNo: nextProps.loadNewSPCCrosstabData.products,
      });

      this.handleNewSpcImport(
        newSpcStructureParams,
        nextProps.loadNewSPCCrosstabData.id,
        false
      );
    }
  }

  getActiveClass = chartType =>
    chartType === this.state.activeChartType ? 'active-chart-type' : '';

  getExportParamsRunView = (crosstabTable, columns, rows, bases) => {
    const sortBy = 'index';
    const partsToShow = this.props.partsToShow
      ? this.props.partsToShow
      : AC_PARTS_TO_SHOW;
    let selectedBase = crosstabTable.selectedBaseName;
    if (
      this.props.selectedBase !== selectedBase &&
      this.props.selectedBaseGroup === 'standard-base'
    ) {
      const [
        { title },
      ] = this.props.activeCrosstabTable.standardBaseList.filter(
        list => list.keyword === this.props.selectedBase
      );
      selectedBase = title;
    }
    const products = crosstabTable.crosstabPerStudy.map(
      crosstabPerStudy => crosstabPerStudy[0].productNo
    );
    const displayRules = [];
    const colExpressionList = [];
    const colHeaderList = [];
    const rowExpressionList = [];
    const rowHeaderList = [];
    const baseList = [];
    const baseHeaderList = [];

    if (crosstabTable.highlightAndFilter) {
      /* sample - start */
      if (crosstabTable.highlightAndFilter.sample) {
        crosstabTable.highlightAndFilter.sample.highlight.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(item, 'sample', 'Highlight')
          );
          return null;
        });
        crosstabTable.highlightAndFilter.sample.filter.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(item, 'sample', 'Filter')
          );
          return null;
        });
      }
      /* sample - end */
      /* weighted - start */
      if (crosstabTable.highlightAndFilter.weighted) {
        crosstabTable.highlightAndFilter.weighted.highlight.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(
              item,
              'weighted',
              'Highlight'
            )
          );
          return null;
        });
        crosstabTable.highlightAndFilter.weighted.filter.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(item, 'weighted', 'Filter')
          );
          return null;
        });
      }
      /* weighted - end */
      /* vertical - start */
      if (crosstabTable.highlightAndFilter.vertical) {
        crosstabTable.highlightAndFilter.vertical.highlight.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(item, 'vp', 'Highlight')
          );
          return null;
        });
        crosstabTable.highlightAndFilter.vertical.filter.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(item, 'vp', 'Filter')
          );
          return null;
        });
      }
      /* vertical - end */
      /* horizontal - start */
      if (crosstabTable.highlightAndFilter.horizontal) {
        crosstabTable.highlightAndFilter.horizontal.highlight.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(item, 'hp', 'Highlight')
          );
          return null;
        });
        crosstabTable.highlightAndFilter.horizontal.filter.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(item, 'hp', 'Filter')
          );
          return null;
        });
      }
      /* horizontal - end */
      /* index - start */
      if (crosstabTable.highlightAndFilter.index) {
        crosstabTable.highlightAndFilter.index.highlight.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(item, 'index', 'Highlight')
          );
          return null;
        });
        crosstabTable.highlightAndFilter.index.filter.map(item => {
          displayRules.push(
            CrosstabUtils.utilExportHighlightObject(item, 'index', 'Filter')
          );
          return null;
        });
      }
      /* index - end */
    }

    crosstabTable.colExpressionList.map(item => {
      colExpressionList.push(item);
      return null;
    });

    crosstabTable.rowExpressionList.map(item => {
      rowExpressionList.push(item);
      return null;
    });

    if (crosstabTable.baseList) {
      crosstabTable.baseList.map(item => {
        baseList.push(item);
        return null;
      });
    }

    if (crosstabTable.baseHeaderList) {
      crosstabTable.baseHeaderList.map(item => {
        baseHeaderList.push(item);
        return null;
      });
    }

    if (columns) {
      columns.map(item => {
        colHeaderList.push(getLabel(item, partsToShow));
        return null;
      });
    }

    if (rows) {
      rows.map(item => {
        rowHeaderList.push(getLabel(item, partsToShow));
        return null;
      });
    }

    if (bases) {
      bases.map(item => {
        baseHeaderList.push(getLabel(item, partsToShow));
        return null;
      });
    }

    return {
      sortBy,
      selectedBase,
      displayRules,
      products,
      colExpressionList,
      colHeaderList,
      rowExpressionList,
      rowHeaderList,
      baseList,
      baseHeaderList,
    };
  };

  getExportParamsToolPalette = (columns, rows, bases) => {
    const products = [this.state.crosstabStudy.pn];
    const colExpressionList = [];
    const colHeaderList = [];
    const rowExpressionList = [];
    const rowHeaderList = [];
    const baseList = [];
    const baseHeaderList = [];
    let selectedBase = '';
    const partsToShow = this.props.partsToShow
      ? this.props.partsToShow
      : AC_PARTS_TO_SHOW;
    if (this.props.crosstabTableList && this.props.crosstabTableList[0]) {
      selectedBase = this.props.crosstabTableList[0].selectedBaseName;
    }
    if (
      this.props.trendStudies.length > 0 &&
      this.state.activeChartType ===
        CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND
    ) {
      this.props.trendStudies.map(study => {
        products.push(study.pn);
        return null;
      });
    }
    if (columns) {
      columns.map(item => {
        colExpressionList.push(item.keyword);
        colHeaderList.push(getLabel(item, partsToShow));
        return null;
      });
    }

    if (rows) {
      rows.map(item => {
        rowExpressionList.push(item.keyword);
        rowHeaderList.push(getLabel(item, partsToShow));
        return null;
      });
    }

    if (bases) {
      bases.map(item => {
        baseList.push(item.keyword);
        baseHeaderList.push(getLabel(item, partsToShow));
        return null;
      });
    }

    return {
      products,
      colExpressionList,
      colHeaderList,
      rowExpressionList,
      rowHeaderList,
      baseList,
      baseHeaderList,
      selectedBase,
    };
  };

  getSelectedTargets = gridType =>
    this.state[gridType].filter(
      gridData => this.state.selectedOptions[gridData.id] >= 0
    );

  handleTargetDrop = (gridData, destinationGridType) => {
    if (destinationGridType !== gridData.gridType) {
      const newGridData = gridData.selectedNodes.map(node => ({
        ...node,
        id: uuid(),
      }));
      this.props.crosstabActions.updateSampleWeighted(
        [...this.state[destinationGridType], ...newGridData],
        destinationGridType
      );
      this.setState({ selectedBase: newGridData[0].id });
    }
  };

  getItemType = type => {
    return type === 'user' ? 'user-defined' : 'standard-base';
  };

  getTitleHeder = () => {
    const renamedCols = [];
    const renamedRows = [];

    this.props.crosstabColumns &&
      this.props.crosstabColumns.length > 0 &&
      this.props.crosstabColumns.forEach((cols, index) => {
        if (cols.isLabelUpdated) {
          renamedCols.push({
            index,
            keyword: cols.keyword,
            updatedTitle: cols.title,
            originalTitle: cols.originalTitle,
          });
        }
      });
    this.props.crosstabRows &&
      this.props.crosstabRows.length > 0 &&
      this.props.crosstabRows.forEach((rows, index) => {
        if (rows.isLabelUpdated) {
          renamedRows.push({
            index,
            keyword: rows.keyword,
            updatedTitle: rows.title,
            originalTitle: rows.originalTitle,
          });
        }
      });

    return {
      ColumnsDataGrid: renamedCols,
      RowsDataGrid: renamedRows,
    };
  };

  checkSelectedBase = () => {
    let selectedBase = '';
    const userDefinedBases = this.props.crosstabBases.map(item => {
      return {
        text: item.originalTitle,
        id: item.id,
        keyword: item.keyword,
        type: 'user',
      };
    });
    const standardBaseLists = this.props.standardBaseLists.map(item => {
      return {
        text: item.label,
        id: item.expression,
        keyword: item.expression,
        type: 'standard',
      };
    });
    const originalBaseLists = [...userDefinedBases, ...standardBaseLists];
    selectedBase = originalBaseLists.filter(
      item =>
        item.keyword === this.props.selectedBaseNode &&
        this.getItemType(item.type) === this.props.selectedBaseGroup
    );
    if (selectedBase.length > 0) {
      selectedBase = selectedBase[0].text;
    } else {
      selectedBase = 'STUDY UNIVERSE';
    }
    return selectedBase;
  };

  handleExportCrosstab = selectedExportOption => {
    const isLocalOrKidsStudy =
      this.state.crosstabStudy.sd.includes('Kids') ||
      this.state.crosstabStudy.sd.includes('SimmonsLOCAL') ||
      (this.state.crosstabStudy.sd.includes('LGBT') &&
        this.props.activeAccountId !== 5261);
    const action =
      selectedExportOption === 'csv' ? TOOL_EXPORT_CSV : TOOL_EXPORT_XLS;
    this.callSaveTrackerFn({ action });
    const exportFormat = selectedExportOption;
    const fieldStart = getOffsetDate(this.state.crosstabStudy.fs);
    const fieldEnd = getOffsetDate(this.state.crosstabStudy.fe);
    const weightType = this.props.crosstabWeightTypes.wt;
    const divisor = this.props.crosstabWeightTypes.dv;
    const selectedWeightName = this.props.crosstabWeightTypes.wn;
    const warningType = isLocalOrKidsStudy ? 3 : this.state.crosstabStudy.wnt;
    const studyDescription = this.state.crosstabStudy.sd;
    const studyType = getExportStudyType(this.state.crosstabStudy);
    let reportType = 'CT';

    if (
      this.state.activeChartType ===
      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE
    ) {
      reportType = 'PE';
    } else if (
      this.state.activeChartType ===
      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND
    ) {
      reportType = 'TR';
    }

    const {
      sortBy,
      selectedBase,
      displayRules = [],
      products,
      colExpressionList,
      colHeaderList,
      rowExpressionList,
      rowHeaderList,
      baseList,
      baseHeaderList,
    } = this.state.shouldExportResult
      ? this.getExportParamsRunView(
          this.state.activeCrosstabTable,
          this.props.columns,
          this.props.rows,
          this.props.bases
        )
      : this.getExportParamsToolPalette(
          this.props.columns,
          this.props.rows,
          this.props.bases
        );

    /* Display Rules Horizantal and Vertical percent must be in % */
    const filteredDisplayRules = displayRules.map(rules => {
      if (rules.element === 'hp' || rules.element === 'vp') {
        return {
          ...rules,
          valueStart: rules.valueStart / 100,
          valueEnd: rules.valueEnd / 100,
        };
      }
      return rules;
    });

    let sortByName = 'none';
    let sortOrder = 'asc';
    let sortColumnIndex = 0;

    if (this.props.crosstabTableList && this.props.crosstabTableList[0]) {
      if (this.props.crosstabTableList[0].sortKey === 'vertical') {
        sortByName = 'vpct';
      } else if (this.props.crosstabTableList[0].sortKey === 'horizontal') {
        sortByName = 'hpct';
      } else {
        sortByName = this.props.crosstabTableList[0].sortKey || 'none';
      }

      sortOrder = this.props.crosstabTableList[0].sortOrder || 'none';
      sortColumnIndex = this.props.crosstabTableList[0].sortColumnIndex || 0;
      if (sortOrder === 'none') {
        sortByName = 'none';
        sortOrder = 'asc';
        sortColumnIndex = 0;
      }
    }
    let fileName = this.handleBlankCrosstabTitle(this.state.crosstabTitle);
    let ctTitle =
      this.state.crosstabTitle === 'TREND'
        ? `${EXPORT_NAME_CONSTANT}_TREND`
        : `${EXPORT_NAME_CONSTANT}_Crosstab`;

    if (fileName === 'untitled' && this.props.toolPaletteSavedName !== '') {
      fileName = this.props.toolPaletteSavedName;
      ctTitle = this.props.toolPaletteSavedName;
    } else if (
      this.props.crosstabTableList &&
      this.props.crosstabTableList[0] &&
      this.props.crosstabTableList[0].title
    ) {
      fileName = this.props.crosstabTableList[0].title;
      ctTitle = this.props.crosstabTableList[0].title;
    }
    const includeFullNameMsg = false;

    let finalSelectedBase = '';
    if (selectedBase === '') {
      finalSelectedBase = this.checkSelectedBase();
    } else {
      finalSelectedBase = selectedBase;
    }

    const crosstabDisplay = {
      intab: this.state.checkBoxes.sample ? 1 : 0,
      weighted: this.state.checkBoxes.weighted ? 1 : 0,
      verticalPercent: this.state.checkBoxes.vertical ? 1 : 0,
      horizontalPercent: this.state.checkBoxes.horizontal ? 1 : 0,
      index: this.state.checkBoxes.index ? 1 : 0,
      hideLowSample: false,
      totalPercent: 0,
      agreeLevel: 'Any Agree',
      days: 'All',
      number: 10,
      itemsToBeReturned: 0,
      studyCode: '',
      viewType: reportType,
      reportType,
      warningType,
      exportFormat,
      studyDescription,
      fieldStart,
      fieldEnd,
      title: ctTitle,
      fileName,
      selectedWeightName,
      selectedBase:
        this.state.crosstabStudy &&
        this.state.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG) &&
        exportFormat === 'csv'
          ? ''
          : finalSelectedBase,
      displayRules: filteredDisplayRules,
      studyType,
      // if full name mode is off for either columns or rows show a message in the export file
      includeFullNameMsg,
    };
    if (reportType !== 'TR') {
      crosstabDisplay.sortBy = sortByName;
      crosstabDisplay.sortOrder = sortOrder;
      crosstabDisplay.sortIdx = sortColumnIndex;
    }

    if (
      baseList.length === 0 &&
      crosstabDisplay.selectedBase !== 'STUDY UNIVERSE' &&
      exportFormat === 'csv'
    ) {
      this.props.crosstabBases.map(item => {
        baseList.push(item.keyword);
        baseHeaderList.push(item.label);
      });
      this.props.standardBaseLists.map(item => {
        baseList.push(item.expression);
        baseHeaderList.push(item.label);
      });
    }

    const titleHeaderList = this.getTitleHeder();
    const crosstabRequest = {
      title: ctTitle,
      fileName,
      weightType,
      products,
      divisor,
      colExpressionList,
      // ensure labels are always uppercase in export
      colHeaderList: colHeaderList.map(c => c.toUpperCase()),
      rowExpressionList,
      // ensure labels are always uppercase in export
      rowHeaderList: rowHeaderList.map(r => r.toUpperCase()),
      baseList,
      baseHeaderList,
      attributes: {
        renamedRows: titleHeaderList.RowsDataGrid,
        renamedCols: titleHeaderList.ColumnsDataGrid,
      },
    };

    this.crosstabExportParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      crosstabRequest,
      crosstabDisplay,
    };
    if (
      selectedExportOption === 'csv' ||
      selectedExportOption === 'pdf' ||
      (this.state.crosstabStudy &&
        this.state.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG))
    ) {
      this.props.crosstabActions.exportCrosstab(this.crosstabExportParams);
    } else if (
      !this.props.userPreference &&
      this.props.loginResponse.data.universityUser
    ) {
      this.props.crosstabActions.exportCrosstab(this.crosstabExportParams);
    } else if (!this.props.userPreference[PREFERENCE_STUDY_SELECTOR_POPUP]) {
      let leftSideBases = [];
      const leftSideSelection = [];
      let studyUniverseEnabled = false;
      const userDefinedBases = this.props.crosstabBases.map(item => {
        return {
          text: item.originalTitle,
          id: item.id,
          keyword: item.keyword,
          type: 'user',
        };
      });
      const standardBaseLists = this.props.standardBaseLists.map(item => {
        return {
          text: item.label,
          id: item.expression,
          keyword: item.expression,
          type: 'standard',
        };
      });
      const originalBaseLists = [...userDefinedBases, ...standardBaseLists];
      const selectedBase = originalBaseLists.filter(
        item =>
          item.keyword === this.props.selectedBaseNode &&
          this.getItemType(item.type) === this.props.selectedBaseGroup
      );

      const selectedPreferenceLabel = this.props.userPreference[
        PREFERENCE_BASE_EXPORT
      ];

      let itemsLeft = [];
      let itemsRight = [];

      if (
        this.props.selectedBase === 'StudyUniverseKey' ||
        this.props.userPreference[PREFERENCE_STUDY_UNIVERSE]
      ) {
        studyUniverseEnabled = true;
      }
      switch (selectedPreferenceLabel) {
        // When base is  User Defined Only
        case PREFERENCE_BASE_EXPORT_LIST[0]: {
          itemsLeft = originalBaseLists.filter(
            item => item.type === 'standard'
          );
          itemsRight = userDefinedBases;
          break;
        }
        // When base is  Standard Only
        case PREFERENCE_BASE_EXPORT_LIST[1]: {
          itemsLeft = originalBaseLists.filter(item => item.type === 'user');
          itemsRight = standardBaseLists;
          break;
        }
        // When base is  User-defined & Standard
        case PREFERENCE_BASE_EXPORT_LIST[2]: {
          itemsLeft = [];
          itemsRight = originalBaseLists;
          break;
        }
        // When base is Current Selection
        case PREFERENCE_BASE_EXPORT_LIST[3]: {
          leftSideBases = originalBaseLists.filter(
            item =>
              !(
                item.keyword === this.props.selectedBaseNode &&
                this.getItemType(item.type) === this.props.selectedBaseGroup
              )
          );
          leftSideBases.map(item => {
            item.selected = true;
            leftSideSelection.push(item.id);
            return item;
          });
          itemsLeft = leftSideBases;
          itemsRight =
            selectedBase === '' ? this.checkSelectedBase() : selectedBase;
          break;
        }
        default:
          break;
      }
      this.handleExportBasePopupBaseClick(
        studyUniverseEnabled,
        itemsLeft,
        itemsRight
      );
    } else if (reportType !== 'TR') {
      this.exportBaseModal.show();
    } else {
      let studyUniverseEnabled = false;
      const userDefinedBases = this.props.crosstabBases.map(item => {
        return {
          text: item.originalTitle,
          id: item.id,
          keyword: item.keyword,
          type: 'user',
        };
      });
      const standardBaseLists = this.props.standardBaseLists.map(item => {
        return {
          text: item.label,
          id: item.expression,
          keyword: item.expression,
          type: 'standard',
        };
      });
      const originalBaseLists = [...userDefinedBases, ...standardBaseLists];
      const selectedBase = originalBaseLists.filter(
        item =>
          item.keyword === this.props.selectedBaseNode &&
          this.getItemType(item.type) === this.props.selectedBaseGroup
      );
      if (this.props.selectedBase === 'StudyUniverseKey') {
        studyUniverseEnabled = true;
      }
      this.handleExportBasePopupBaseClick(
        studyUniverseEnabled,
        [],
        selectedBase === '' ? this.checkSelectedBase() : selectedBase
      );
    }
  };

  handleBlankCrosstabTitle = crosstabTitle => {
    if (crosstabTitle === 'TREND') {
      return exportFileTitle('TREND');
    }

    return exportFileTitle('Crosstab');
  };

  handleGridSwitch = viewerGridType => {
    let action = '';
    switch (viewerGridType) {
      case 'Private Eye View':
        action = TOOL_CHART_PRIVATE_EYE;
        break;
      case 'Crosstab View':
        action = TOOL_CHART_CROSSTAB;
        break;
      case 'Quad':
        action = TOOL_CHART_QUAD;
        break;
      default:
        break;
    }
    if (action !== '') {
      this.callSaveTrackerFn({ action });
    }
    switch (viewerGridType) {
      case CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE:
        this.props.crosstabActions.updateCrosstabGrid(
          this.state.activeCrosstabTable.idKey,
          { viewerGridType }
        );
        this.setState({ activeChartType: viewerGridType }, () =>
          this.props.cbCrossTabViewTypeChanged(this.state.activeChartType)
        );
        break;
      case CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.CROSSTAB:
        this.props.crosstabActions.updateCrosstabGrid(
          this.state.activeCrosstabTable.idKey,
          { viewerGridType }
        );
        this.setState({ activeChartType: viewerGridType }, () =>
          this.props.cbCrossTabViewTypeChanged(this.state.activeChartType)
        );
        break;
      case CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART:
        if (
          this.state.activeCrosstabTable &&
          this.state.activeCrosstabTable.colExpressionList &&
          this.state.activeCrosstabTable.colExpressionList.length > 1
        ) {
          this.setState({ activeChartType: viewerGridType }, () => {
            this.props.crosstabActions.updateCrosstabGrid(
              this.state.activeCrosstabTable.idKey,
              { viewerGridType }
            );
            this.props.cbCrossTabViewTypeChanged(this.state.activeChartType);
          });
        } else {
          this.warningQuadModal.show();
        }
        break;
      case CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND:
        if (
          this.state.activeCrosstabTable &&
          this.state.activeCrosstabTable.crosstabPerStudy &&
          this.state.activeCrosstabTable.crosstabPerStudy.length < 2
        ) {
          // this.warningModal.show();
        } else {
          this.props.crosstabActions.updateCrosstabGrid(
            this.state.activeCrosstabTable.idKey,
            { viewerGridType }
          );
          this.setState({ activeChartType: viewerGridType }, () =>
            this.props.cbCrossTabViewTypeChanged(this.state.activeChartType)
          );
        }
        break;
      case CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.CORR_CLUSTER: {
        this.props.enableCorrespondence();
        break;
      }
      default:
        this.props.crosstabActions.updateCrosstabGrid(
          this.state.activeCrosstabTable.idKey,
          {
            viewerGridType: CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE,
          }
        );
        this.setState({
          activeChartType: CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE,
        });
        break;
    }
  };

  trackTrendChartClick = () => {
    this.callSaveTrackerFn({ action: TOOL_CHART_TREND });
  };

  findSelectedBase = (selectedBaseArr, selectedBaseID) => {
    let out = selectedBaseID;
    if (selectedBaseArr.length > 0) {
      out = selectedBaseArr[0].originalTitle;
    } else if (
      CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE === selectedBaseID
    ) {
      out = CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE; // 'STUDY UNIVERSE';
    }
    return out;
  };

  handleBaseSelectionChange = (selectedBaseID, gridType) => {
    if (
      (this.state.BasesDataGrid && this.state.BasesDataGrid.length > 0) ||
      selectedBaseID === 'StudyUniverseKey'
    ) {
      const selectedBaseArray = this.state.BasesDataGrid.filter(
        elment => elment.id === selectedBaseID
      );

      let selectedBase = 0;
      if (selectedBaseArray.length) {
        selectedBase =
          this.state.BasesDataGrid.indexOf(selectedBaseArray[0]) + 1;
      }
      if (
        this.state.activeCrosstabTable &&
        this.state.activeCrosstabTable.idKey &&
        selectedBaseID === 'StudyUniverseKey'
      ) {
        this.props.crosstabActions.updateCrosstabGrid(
          this.state.activeCrosstabTable.idKey,
          {
            selectedBaseName:
              this.state.activeCrosstabTable &&
              this.state.activeCrosstabTable.crosstabPerStudy &&
              this.state.activeCrosstabTable.crosstabPerStudy[0] &&
              this.state.activeCrosstabTable.crosstabPerStudy[0][selectedBase]
                ? this.state.activeCrosstabTable.crosstabPerStudy[0][
                    selectedBase
                  ].filter
                : this.findSelectedBase(selectedBaseArray, selectedBaseID),
            selectedBase,
            selectedBaseID,
            selectedBaseNode: selectedBaseID,
            selectedBaseGroup: 'user-defined',
          }
        );
      }
      if (
        this.state.activeCrosstabTable &&
        this.state.activeCrosstabTable.idKey &&
        gridType === 'BasesDataGrid'
      ) {
        this.props.crosstabActions.updateCrosstabGrid(
          this.state.activeCrosstabTable.idKey,
          {
            selectedBaseName:
              this.state.activeCrosstabTable &&
              this.state.activeCrosstabTable.crosstabPerStudy &&
              this.state.activeCrosstabTable.crosstabPerStudy[0] &&
              this.state.activeCrosstabTable.crosstabPerStudy[0][selectedBase]
                ? this.state.activeCrosstabTable.crosstabPerStudy[0][
                    selectedBase
                  ].filter
                : this.findSelectedBase(selectedBaseArray, selectedBaseID),
            selectedBase,
            selectedBaseID,
            selectedBaseNode: selectedBaseID,
            selectedBaseGroup: 'user-defined',
          }
        );
      }
      if (selectedBaseArray[0] || selectedBaseID === 'StudyUniverseKey') {
        this.props.crosstabActions.setSelectedBase(
          selectedBaseID,
          selectedBaseID === 'StudyUniverseKey'
            ? selectedBaseID
            : selectedBaseArray[0].keyword,
          'user-defined'
        );
      }
      this.setState({ userToggled: true });
    }
    if (
      this.props.standardBaseLists &&
      this.props.standardBaseLists.length > 0 &&
      selectedBaseID !== 'StudyUniverseKey'
    ) {
      const selectedStandardBaseArray = this.props.standardBaseLists.filter(
        elment => elment.expression === selectedBaseID
      );
      let selectedBaseName;
      this.state.activeCrosstabTable &&
        this.state.activeCrosstabTable.standardBaseList &&
        this.state.activeCrosstabTable.standardBaseList.forEach(elems => {
          if (elems.keyword === selectedBaseID) {
            selectedBaseName = elems.title;
          }
        });
      if (
        this.state.activeCrosstabTable &&
        this.state.activeCrosstabTable.idKey &&
        gridType === 'StandardBases'
      ) {
        let selectedBase = 0;
        this.state.activeCrosstabTable &&
          this.state.activeCrosstabTable.crosstabPerStudy &&
          this.state.activeCrosstabTable.crosstabPerStudy[0].forEach(
            (elems, index) => {
              if (elems.filter === selectedBaseName) {
                selectedBase = index;
              }
            }
          );
        if (
          this.props.crosstabBaseList.baseList.indexOf(selectedBaseID) === -1
        ) {
          this.props.runCrosstab(gridType, selectedBaseID);
        } else {
          this.props.crosstabActions.updateCrosstabGrid(
            this.state.activeCrosstabTable.idKey,
            {
              selectedBaseName:
                this.state.activeCrosstabTable &&
                this.state.activeCrosstabTable.crosstabPerStudy &&
                this.state.activeCrosstabTable.crosstabPerStudy[0] &&
                this.state.activeCrosstabTable.crosstabPerStudy[0][selectedBase]
                  ? this.state.activeCrosstabTable.crosstabPerStudy[0][
                      selectedBase
                    ].filter
                  : this.findSelectedBase(
                      selectedStandardBaseArray,
                      selectedBaseID
                    ),
              selectedBase,
              selectedBaseID,
              selectedBaseNode: selectedBaseID,
              selectedBaseGroup: 'standard-base',
            }
          );
        }
      }
      if (selectedStandardBaseArray[0]) {
        this.props.crosstabActions.setSelectedBase(
          selectedBaseID,
          selectedStandardBaseArray[0].expression,
          'standard-base'
        );
      }
      this.setState({ userToggled: true });
    }
  };

  studyDropdownOptions = () => {
    if (this.state.studies.length > 6) {
      return [
        ...this.state.studies.slice(0, 6).map(study => ({
          label: study.sd,
          value: study.pn,
          ...study,
        })),
        { label: 'More', value: 'More', className: 'more-options' },
      ];
    }

    return [
      ...this.state.studies.map(study => ({
        label: study.sd,
        value: study.pn,
        ...study,
      })),
      { label: 'More', value: 'More', className: 'more-options' },
    ];
  };

  handleStudyChange = val => {
    if (val.value === 'More') {
      this.studyModal.show();
    } else {
      this.props.crosstabActions.addDDNHCSData([]);
      this.props.crosstabActions.clearSampleWeightedKPIs();
      this.props.quickReportsActions.clearSampleWeightedKPIs();

      let dataScreen = this.props.dataScreen
        ? this.props.dataScreen
        : CROSSTAB_CONSTANT;
      if (
        this.props.dataScreen &&
        this.props.dataScreen.includes(DATAHAUL_CONSTANT)
      ) {
        dataScreen = this.props.dataScreen.toLowerCase();
      }
      this.props.studyActions.updateModuleStudy(dataScreen, {
        ...val,
        wt: 1,
      });
      this.props.dictionaryActions.clearTreeLoadNodeList();
      const fetchStandardBasetParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: val.pn,
      };
      if (!this.props.loginResponse.data.universityUser) {
        this.props.crosstabActions.fetchStandardBaseList(
          fetchStandardBasetParams
        );
      }
      if (this.props.crosstabStudy.pn !== val.pn) {
        this.props.crosstabActions.exportBaseSelectionList([], [], false);
      }
    }
  };

  openCrosstabs = () => {
    this.callSaveTrackerFn({ action: TOOL_OPEN_CROSSTAB });
    this.props.crosstabActions.showSavedCrosstabs(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId
    );
  };

  importSPCHandler = () => {
    this.callSaveTrackerFn({ action: TOOL_IMPORT_SPC });
  };

  showMoreItems = (data, dataGrid, toggleLabelFlag) => {
    if (data.length > defaultCount[dataGrid] && this.state.showMore[dataGrid]) {
      return this.renderGrids(
        data.slice(defaultCount[dataGrid]),
        dataGrid,
        toggleLabelFlag
      );
    }
    return null;
  };

  showStandardBases = () => {
    if (
      this.props.standardBaseLists.length > defaultCount.StandardBases &&
      this.state.showMore.StandardBases
    ) {
      return this.props.standardBaseLists
        .slice(0, this.props.standardBaseLists.length)
        .map((element, index) => {
          return (
            <div
              key={element.expression + index}
              className="base-grid-items line-height"
            >
              {this.renderToggleButton(element.expression, 'StandardBases')}
              <p className="crosstab-recent-item-title">
                <span
                  onClick={() =>
                    this.handleBaseSelectionChange(
                      element.expression,
                      'StandardBases'
                    )
                  }
                >
                  {element.label}
                </span>
              </p>
            </div>
          );
        });
    }
    if (
      this.props.standardBaseLists &&
      this.props.standardBaseLists.length > 0
    ) {
      return this.props.standardBaseLists
        .slice(0, defaultCount.StandardBases)
        .map((element, index) => {
          return (
            <div
              key={element.expression + index}
              className="base-grid-items line-height"
            >
              {this.renderToggleButton(element.expression, 'StandardBases')}
              <p className="crosstab-recent-item-title">
                <span
                  onClick={() =>
                    this.handleBaseSelectionChange(
                      element.expression,
                      'StandardBases'
                    )
                  }
                >
                  {element.label}
                </span>
              </p>
            </div>
          );
        });
    }
    return null;
  };

  showMoreLabel = (data, dataGrid) => {
    if (data.length > defaultCount[dataGrid]) {
      if (this.state.showMore[dataGrid]) {
        return (
          <button
            className="more-btn"
            onClick={() =>
              this.setState({
                showMore: { ...this.state.showMore, [dataGrid]: false },
              })
            }
          >
            <strong>Less</strong>
          </button>
        );
      }
      return (
        <button
          className="more-btn"
          onClick={() =>
            this.setState({
              showMore: { ...this.state.showMore, [dataGrid]: true },
            })
          }
        >
          <strong title={this.state.selectedBase}>More</strong>
        </button>
      );
    }
    return null;
  };

  handleDelete = (currentObjectId, gridType) => {
    this.props.crosstabActions.updateSampleWeighted(
      this.state[gridType].filter(
        crosstabEntry => crosstabEntry.id !== currentObjectId
      ),
      gridType
    );
  };

  updateGridData = (currentObject, updatedObjectProps, gridType) => {
    const updatedObject = {
      ...currentObject,
      ...updatedObjectProps,
    };
    this.props.crosstabActions.updateSampleWeighted(
      this.state[gridType].reduce((acc, currentValue) => {
        if (currentValue.id === updatedObject.id) {
          acc.push({
            ...currentValue,
            ...updatedObject,
          });
        } else {
          acc.push(currentValue);
        }
        return acc;
      }, []),
      gridType
    );
  };

  handleNewSpcImport = (
    newSpcStructureParams,
    savedCrosstbId,
    importSPC = true
  ) => {
    const dictionaryDetailsCalls = [];
    const crosstabTitle = newSpcStructureParams.title;

    if (
      newSpcStructureParams.basesKeywordList &&
      newSpcStructureParams.basesKeywordList.length > 0
    )
      dictionaryDetailsCalls.push(
        this.props.crosstabActions.getDictionaryDataDetails({
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.crosstabStudy.pn,
          expressionList: newSpcStructureParams.basesKeywordList,
          gridType: 'BasesGrid',
        })
      );

    if (
      newSpcStructureParams.columnKeywordList &&
      newSpcStructureParams.columnKeywordList.length > 0
    )
      dictionaryDetailsCalls.push(
        this.props.crosstabActions.getDictionaryDataDetails({
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.crosstabStudy.pn,
          expressionList: newSpcStructureParams.columnKeywordList,
          gridType: 'ColumnsGrid',
        })
      );

    if (
      newSpcStructureParams.rowsKeywordList &&
      newSpcStructureParams.rowsKeywordList.length > 0
    )
      dictionaryDetailsCalls.push(
        this.props.crosstabActions.getDictionaryDataDetails({
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.crosstabStudy.pn,
          expressionList: newSpcStructureParams.rowsKeywordList,
          gridType: 'RowsGrid',
        })
      );

    Promise.all(dictionaryDetailsCalls)
      .then(() => {
        const importNewSpcParams = rebuildAutocodeNodesForSPC(
          newSpcStructureParams,
          this.props.DictionaryDetails
        );
        importNewSpcParams.id = savedCrosstbId;
        // console.log('Updated newSpcStructureParams:', importNewSpcParams);
        // console.log('DictionaryDetails:', this.props.DictionaryDetails);

        this.props.crosstabActions.importNewSPC(importNewSpcParams, importSPC);
        this.setState({ crosstabTitle }, () => this.showWarningOpenCrosstab());
      })
      .catch(e => console.warn(e));
  };

  handleImportSPC = (data, fileName) => {
    // console.log(checkSPCForVersion(data));

    if (checkSPCForVersion(data)) {
      const spcObject = JSON.parse(data);

      const newSpcStructureParams = rebuildGridObjectsFromNewSPC({
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        spcObject,
        partsToShow: this.props.partsToShow,
        productNo: [this.props.crosstabStudy.pn],
      });

      this.handleNewSpcImport(newSpcStructureParams);
    } else {
      const baseList = [];
      const baseHeaderList = [];
      const colExpressionList = [];
      const colHeaderList = [];
      const rowExpressionList = [];
      const rowHeaderList = [];
      const titleColList = [];
      const titleRowList = [];
      const str = reformatSpcArray(data.split('\n'));
      let baseLength;
      let columnLength;
      let rowsLength;
      let titleColLength;
      let titleRowLength;
      if (str[2] !== '0') {
        baseLength = parseInt(str[2], 10);
        for (let i = 3; i <= 2 + (baseLength * 2 - 1); i += 2) {
          baseHeaderList.push(str[i]);
        }
        for (let j = 4; j <= 3 + (baseLength * 2 - 1); j += 2) {
          baseList.push(str[j]);
        }
      } else {
        baseLength = 0;
      }
      const beginColumns = 2 + baseLength * 2 + 1;
      if (str[beginColumns] !== '0') {
        columnLength = parseInt(str[beginColumns], 10);
        for (
          let i = beginColumns + 1;
          i <= beginColumns + (columnLength * 2 - 1);
          i += 2
        ) {
          if (str[i]) {
            colHeaderList.push(str[i]);
          }
        }
        for (
          let j = beginColumns + 2;
          j <= beginColumns + columnLength * 2 + 1;
          j += 2
        ) {
          if (str[j]) {
            colExpressionList.push(str[j]);
          }
        }
      } else {
        columnLength = 0;
      }
      const beginRows = beginColumns + columnLength * 2 + 1;
      if (str[beginRows] !== '0') {
        rowsLength = parseInt(str[beginRows], 10);
        for (
          let i = beginRows + 1;
          i <= beginRows + (rowsLength * 2 - 1);
          i += 2
        ) {
          if (str[i]) {
            rowHeaderList.push(str[i]);
          }
        }
        for (
          let j = beginRows + 2;
          j <= beginRows + rowsLength * 2 + 1;
          j += 2
        ) {
          if (str[j]) {
            rowExpressionList.push(str[j]);
          }
        }
      } else {
        rowsLength = 0;
      }
      const beginTitleCols = beginRows + rowsLength * 2 + 1;
      if (str[beginTitleCols] !== '0') {
        titleColLength = parseInt(str[beginTitleCols], 10);
        for (
          let j = beginTitleCols + 1;
          j <= beginTitleCols + titleColLength;
          j += 1
        ) {
          titleColList.push(str[j]);
        }
      } else {
        titleColLength = 0;
      }
      const beginTitleRows = beginTitleCols + titleColLength + 1;
      if (str[beginTitleRows] !== '0') {
        titleRowLength = parseInt(str[beginTitleRows], 10);
        for (
          let i = beginTitleRows + 1;
          i <= beginTitleRows + titleRowLength;
          i += 1
        ) {
          titleRowList.push(str[i]);
        }
      }
      const crosstabTitle = fileName.replace('.spc', '');
      const importSPCParams = {
        products: [this.props.crosstabStudy.pn],
        weightType: this.props.crosstabWeightTypes.wt,
        divisor: this.props.crosstabWeightTypes.dv,
        title: crosstabTitle,
        baseList,
        baseHeaderList,
        colExpressionList,
        colHeaderList,
        rowExpressionList,
        rowHeaderList,
        titleColList,
        titleRowList,
      };
      this.props.crosstabActions.importSPC(importSPCParams);
      this.setState({ crosstabTitle }, () => this.showWarningOpenCrosstab());
    }
  };

  showWarningOpenCrosstab = () => {
    // if (this.props.crosstabTableList && this.props.crosstabTableList.length) {
    //   this.afterOpenCrosstabModal.show();
    // }
    if (
      this.props.crosstabTableList &&
      this.props.crosstabTableList.length &&
      this.state.shareCrossTabModalFlag === false
    ) {
      this.afterOpenCrosstabModal.show();
    }
  };

  exportNewSpc = ctTitle => {
    const dataList = [];
    const highlightAndFilterRules =
      this.props.activeCrosstabTable.conditionalFormatting &&
      this.props.activeCrosstabTable.conditionalFormatting === 'HNF'
        ? this.props.activeCrosstabTable.highlightAndFilter
        : {
            sample: { highlight: [], filter: [] },
            weighted: { highlight: [], filter: [] },
            vertical: { highlight: [], filter: [] },
            horizontal: { highlight: [], filter: [] },
            index: { highlight: [], filter: [] },
          };

    dataList.push(
      JSON.stringify(
        buildSPC2Object(
          this.state.crosstabStudy.wt,
          `${ctTitle}`,
          this.state.crosstabStudy.dv,
          [this.state.crosstabStudy.pn],
          this.props.bases,
          this.props.rows,
          this.props.columns,
          this.props.partsToShow,
          this.props.activeCrosstabTable.conditionalFormatting
            ? this.props.activeCrosstabTable.conditionalFormatting
            : 'DefaultFilter',
          highlightAndFilterRules
        ),
        null,
        4
      )
    );

    const link = document.createElement('a');
    link.href = makeTextFile(dataList);
    document.body.appendChild(link);
    link.setAttribute('type', 'hidden');
    link.download = `${ctTitle}.spc`;
    link.click();
  };

  handleExportSPC = () => {
    this.callSaveTrackerFn({ action: TOOL_EXPORT_SPC });
    let ctTitle = this.handleBlankCrosstabTitle(this.state.crosstabTitle);
    if (ctTitle === 'untitled' && this.props.toolPaletteSavedName !== '') {
      ctTitle = this.props.toolPaletteSavedName;
    } else if (
      this.props.crosstabTableList &&
      this.props.crosstabTableList[0] &&
      this.props.crosstabTableList[0].title
    ) {
      ctTitle = this.props.crosstabTableList[0].title;
    }

    if (SPC2) {
      this.exportNewSpc(ctTitle);
    } else {
      const dataList = [];
      const currentStudy = this.state.crosstabStudy.st;
      dataList.push(currentStudy, ' ');
      if (this.props.bases !== undefined) {
        dataList.push(this.props.bases.length);
        this.props.bases.map(item => {
          dataList.push(item.title);
          dataList.push(item.keyword);
          return item;
        });
      } else {
        dataList.push(0);
      }
      if (this.props.columns !== undefined) {
        dataList.push(this.props.columns.length);
        this.props.columns.map(item => {
          dataList.push(item.title);
          dataList.push(item.keyword);
          return item;
        });
      } else {
        dataList.push(0);
      }
      if (this.props.rows !== undefined) {
        dataList.push(this.props.rows.length);
        this.props.rows.map(item => {
          dataList.push(item.title);
          dataList.push(item.keyword);
          return item;
        });
      } else {
        dataList.push(0);
      }

      const titleHeaderList = this.getTitleHeder();
      if (!_.isEmpty(titleHeaderList)) {
        if (
          titleHeaderList.ColumnsDataGrid &&
          titleHeaderList.ColumnsDataGrid.length > 0
        ) {
          dataList.push(titleHeaderList.ColumnsDataGrid.length);
          titleHeaderList.ColumnsDataGrid.map(item =>
            dataList.push(
              `${item.index}||${item.keyword}||${item.updatedTitle}||${item.originalTitle}`
            )
          );
        } else {
          dataList.push(0);
        }
        if (
          titleHeaderList.RowsDataGrid &&
          titleHeaderList.RowsDataGrid.length > 0
        ) {
          dataList.push(titleHeaderList.RowsDataGrid.length);
          titleHeaderList.RowsDataGrid.map(item =>
            dataList.push(
              `${item.index}||${item.keyword}||${item.updatedTitle}||${item.originalTitle}`
            )
          );
        } else {
          dataList.push(0);
        }
      }
      dataList.push(0, 0);
      const link = document.createElement('a');
      link.href = makeTextFile(dataList.join('\n'));
      document.body.appendChild(link);
      link.setAttribute('type', 'hidden');
      // let ctTitle = this.handleBlankCrosstabTitle(this.state.crosstabTitle);
      // if (ctTitle === 'untitled' && this.props.toolPaletteSavedName !== '') {
      //   ctTitle = this.props.toolPaletteSavedName;
      // } else if (
      //   this.props.crosstabTableList &&
      //   this.props.crosstabTableList[0] &&
      //   this.props.crosstabTableList[0].title
      // ) {
      //   ctTitle = this.props.crosstabTableList[0].title;
      // }
      link.download = `${ctTitle}.spc`;
      link.click();
    }
  };

  handleMetricCheckboxesChange = (checkBoxKey, newMetrics) => {
    let action = '';
    switch (checkBoxKey) {
      case 'hnf':
        action = CROSSTAB_CELL_HIGHLIGHT_FILTERING_OPEN;
        break;
      case 'sample':
        action = TOOL_VIEW_SAMPLE;
        break;
      case 'weighted':
        action = TOOL_VIEW_WEIGHTED;
        break;
      case 'vertical':
        action = TOOL_VIEW_VERTICAL;
        break;
      case 'horizontal':
        action = TOOL_VIEW_HORIZONTAL;
        break;
      case 'index':
        action = TOOL_VIEW_INDEX;
        break;
      default:
        break;
    }
    this.callSaveTrackerFn({ action });
    let checkBoxes;
    if (!newMetrics) {
      checkBoxes = { ...this.state.checkBoxes };
      checkBoxes[checkBoxKey] = !checkBoxes[checkBoxKey];
    } else {
      checkBoxes = newMetrics;
    }

    const cellElementList = [
      ...CrosstabUtils.getDefaultCells(this.props.crosstabWeightTypes),
    ].map(cellElement => ({
      ...cellElement,
      isVisible: checkBoxes[cellElement.key],
    }));

    this.setState(
      () => ({ checkBoxes }),
      () => {
        this.props.handleMetricsChange(cellElementList);
      }
    );
    if (checkBoxKey === 'hnf') {
      this.toolpaletteHiglights.show();
      sendVPVHotjarEvent(HJ_CROSSTAB_HIGHLIGHTING_FILTERING);
    }
  };

  handleHighlightAndFilter = highlightAndFilter =>
    this.props.crosstabActions.updateCrosstabGrid(
      this.state.activeCrosstabTable.idKey,
      { highlightAndFilter }
    );

  handleConditionalFiltering = conditionalFormatting =>
    this.props.crosstabActions.updateCrosstabGrid(
      this.state.activeCrosstabTable.idKey,
      { conditionalFormatting }
    );

  handleRadioOptions = selectedOption => {
    this.handleConditionalFiltering(selectedOption ? 'HNF' : '');
    if (!selectedOption) {
      this.handleHighlightAndFilter({
        sample: { highlight: [], filter: [] },
        weighted: { highlight: [], filter: [] },
        vertical: { highlight: [], filter: [] },
        horizontal: { highlight: [], filter: [] },
        index: { highlight: [], filter: [] },
      });
    }
  };

  selectGridItem = (e, gridEntryid, index) => {
    if (e.ctrlKey || e.metaKey) {
      this.setState({
        selectedOptions: {
          ...this.state.selectedOptions,
          [gridEntryid]: index,
        },
      });
    } else if (e.shiftKey) {
      console.warn(gridEntryid);
    } else {
      this.setState({
        selectedOptions: {
          [gridEntryid]: index,
        },
      });
    }
  };

  deleteSelected = gridType => {
    let deletedIndex;
    this.props.crosstabActions.updateSampleWeighted(
      this.state[gridType].filter(gridData => {
        if (this.state.selectedOptions[gridData.id] >= 0) {
          deletedIndex = this.state.selectedOptions[gridData.id];
          this.props.crosstabActions.updateCrosstabTitleList(
            deletedIndex,
            gridType
          );
        }
        return !(this.state.selectedOptions[gridData.id] >= 0);
      }),
      gridType
    );
  };

  clearSelected = () => {
    this.callSaveTrackerFn({ action: TOOL_VIEW_CLEAR_ALL });
    this.props.crosstabActions.clearSampleWeighted('ColumnsDataGrid');
    this.props.crosstabActions.clearSampleWeighted('RowsDataGrid');
    this.props.crosstabActions.clearSampleWeighted('BasesDataGrid');
    this.props.crosstabActions.clearSampleWeighted('ScratchDataGrid');
    this.props.crosstabActions.deleteCrosstabGrid();
    this.props.crosstabActions.setSelectedBase(
      CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
      CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
      CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE
    );
    this.props.studyActions.clearTrendStudies();
    this.props.resetHighlightFilterState();
    this.props.crosstabActions.clearSampleWeightedKPIs();

    this.props.quickReportsActions.clearSampleWeightedKPIs();
    this.props.dictionaryActions.setDataPointAlreadyAdded(false);
    this.props.dictionaryActions.dictionaryTargetReset();
    this.props.resetSmarchSearch();
    this.props.resetTitle();
  };

  isEditButtonEnabled = gridType => {
    const selectedGridEntries = this.state[gridType].filter(
      gridData => this.state.selectedOptions[gridData.id] >= 0
    );
    if (selectedGridEntries.length === 1) {
      return 'edit-selected';
    }
    return 'edit-selected hidden';
  };

  handleEditButton = gridType => {
    const action = getActionName(ACTION_TYPE_TOOL_GRID, gridType);
    if (action) {
      this.callSaveTrackerFn({ action });
    }
    const selectedGridEntries = this.state[gridType].filter(
      gridData => this.state.selectedOptions[gridData.id] >= 0
    );
    if (selectedGridEntries.length === 1) {
      this.props.handleCrosstabEdit(
        selectedGridEntries[0].id,
        selectedGridEntries[0].dataSmartSearch,
        selectedGridEntries[0].keyword
      );
    }
  };

  closeLoadCrosstabModal = () => {
    this.savedCrosstabsModal.hide();
    this.showWarningOpenCrosstab();
  };

  callSaveTrackerFn = ({ action, attributes }) => {
    const productNo =
      this.props.crosstabStudy !== undefined
        ? this.props.crosstabStudy.pn
        : undefined;
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName:
        this.props.dataScreen !== undefined
          ? this.props.dataScreen
          : 'Crosstab',
      action,
      attributes,
    });
  };

  handleSaveTrends = () => {
    this.props.handleSaveCrosstab();
  };

  renderLength = data => (data ? data.length : 0);

  renderRowsColumnsBases = (data, dataGrid, toggleLabelFlag) =>
    this.renderGrids(
      data.slice(0, defaultCount[dataGrid]),
      dataGrid,
      toggleLabelFlag
    );

  renderToggleButton = (gridEntryId, gridType) => {
    if (gridType === 'BasesDataGrid' || gridType === 'StandardBases') {
      return (
        <span className="radio-toggle">
          <label className="rb-switcher blue" htmlFor={gridEntryId}>
            <input
              type="radio"
              name="study"
              id={gridEntryId}
              checked={this.state.selectedBase === gridEntryId}
              onClick={() =>
                this.handleBaseSelectionChange(gridEntryId, gridType)
              }
            />{' '}
            <i />
          </label>
        </span>
      );
    }
    return false;
  };

  updateCrosstabTitleHeader = updatedData => {
    let gridCategory = '';
    let originalList = [];
    let index = 0;
    switch (updatedData.gridCategory) {
      case 'ColumnsDataGrid':
        gridCategory = 'column';
        break;
      case 'RowsDataGrid':
        gridCategory = 'row';
        break;
      default:
        gridCategory = '';
    }
    if (gridCategory !== '' && gridCategory === 'column') {
      originalList = this.props.crosstabColumns;
    } else {
      originalList = this.props.crosstabRows;
    }
    if (originalList.length !== 0) {
      index = originalList.findIndex(item => {
        if (item.keyword === updatedData.keyword) {
          return true;
        }
        return false;
      });
      updatedData.index = index;
    }
    this.props.crosstabActions.updateCrosstabTitleHeader(updatedData);
  };

  handleExportBasePopupBaseClick = (studyUniverse, leftItems, rightItems) => {
    const exportParams = { ...this.crosstabExportParams };
    const itemsRight = [...rightItems];
    this.props.crosstabActions.exportBaseSelectionList(
      leftItems,
      rightItems,
      studyUniverse
    );
    if (itemsRight.length > 0) {
      if (itemsRight[0].text === STUDY_UNIVERSE_LABEL) {
        exportParams.crosstabDisplay.selectedBase = itemsRight[0].text;
      } else {
        if (this.props.selectedBaseGroup !== 'standard-base') {
          exportParams.crosstabDisplay.selectedBase = itemsRight[0].text;
        }
        if (this.props.selectedBase === 'StudyUniverseKey') {
          exportParams.crosstabDisplay.selectedBase = STUDY_UNIVERSE_LABEL;
        }
      }
      if (this.props.cbCrosstabRunType !== 'Trend') {
        exportParams.crosstabRequest.baseHeaderList = itemsRight
          .filter(item => item.text !== STUDY_UNIVERSE_LABEL)
          .map(item => item.text);
        exportParams.crosstabRequest.baseList = itemsRight
          .filter(item => item.text !== STUDY_UNIVERSE_LABEL)
          .map(item => item.keyword);
      } else if (
        this.props.userPreference[PREFERENCE_BASE_EXPORT] ===
          'User-Defined & Standard' ||
        this.props.userPreference[PREFERENCE_BASE_EXPORT] === 'Standard Only'
      ) {
        exportParams.crosstabRequest.baseHeaderList = itemsRight
          .filter(item => item.text !== STUDY_UNIVERSE_LABEL)
          .map(item => item.text);
        exportParams.crosstabRequest.baseList = itemsRight
          .filter(item => item.text !== STUDY_UNIVERSE_LABEL)
          .map(item => item.keyword);
      } else {
        let baseHeaderList = itemsRight
          .filter(item => item.text !== STUDY_UNIVERSE_LABEL)
          .map(item => item.text);
        if (
          baseHeaderList.length > 0 &&
          baseHeaderList[0] !== exportParams.crosstabDisplay.selectedBase
        ) {
          baseHeaderList = exportParams.crosstabRequest.baseHeaderList;
        } else {
          baseHeaderList = itemsRight
            .filter(item => item.text !== STUDY_UNIVERSE_LABEL)
            .map(item => item.text);
        }
        exportParams.crosstabRequest.baseHeaderList = baseHeaderList;
        let baseList = itemsRight
          .filter(item => item.text !== STUDY_UNIVERSE_LABEL)
          .map(item => item.keyword);
        if (
          baseHeaderList.length > 0 &&
          baseHeaderList[0] !== exportParams.crosstabDisplay.selectedBase
        ) {
          baseList = exportParams.crosstabRequest.baseList;
        } else {
          baseList = itemsRight
            .filter(item => item.text !== STUDY_UNIVERSE_LABEL)
            .map(item => item.keyword);
        }
        exportParams.crosstabRequest.baseList = baseList;
      }
    } else if (this.props.selectedBase === 'StudyUniverseKey') {
      exportParams.crosstabDisplay.selectedBase = STUDY_UNIVERSE_LABEL;
      exportParams.crosstabRequest.baseHeaderList = [];
      exportParams.crosstabRequest.baseList = [];
    }
    exportParams.crosstabDisplay.includeStudyUniverse = studyUniverse;
    this.props.crosstabActions.exportCrosstab(exportParams);
    this.exportBaseModal.hide();
  };

  getTrendType() {
    if (this.props.crosstabStudy && this.props.crosstabStudy.sti) {
      const studyGroup = CrosstabUtils.getStudyGroup(
        this.props.crosstabStudy.sti,
        this.props.studies
      );
      return studyGroup.tt;
    }
    return undefined;
  }

  showTrendModal = () => {
    this.trendModal.show();
  };

  isTrendButtonDisabled = () => {
    const { crosstabStudy } = this.props;
    const trendTypeValue = this.getTrendType();
    if (trendTypeValue === 3) {
      return false;
    }
    if (crosstabStudy && IPSOS_DISABLED_STUDY_LIST.length > 0) {
      if (IPSOS_DISABLED_STUDY_LIST.indexOf(crosstabStudy.st) !== -1) {
        return false;
      }
    }
    return true;
  };

  renderGrids = (gridData, gridType, toggleLabelFlag) =>
    gridData.map((gridEntry, index) => {
      let gridTitle;
      if (gridEntry.dataSmartSearch && gridEntry.dataSmartSearch.objectsAdded) {
        const objectsAdded = gridEntry.dataSmartSearch.objectsAdded;
        if (objectsAdded.length > 0 && objectsAdded.length === 1) {
          const label = objectsAdded[0].dataSmartSearchObjectsCreated
            ? objectsAdded[0].breadcrumbs
            : CrosstabUtils.filterLabel(
                `${objectsAdded[0].shortTextCatgView}`,
                `${objectsAdded[0].breadcrumbs}`
              );
          gridTitle = label;
        } else {
          gridTitle = '';
          objectsAdded.forEach(item => {
            let textValue = '';
            if (item.breadcrumbs) {
              textValue = item.dataSmartSearchObjectsCreated
                ? item.breadcrumbs
                : CrosstabUtils.filterLabel(
                    `${item.shortTextCatgView}`,
                    `${item.breadcrumbs}`
                  );
            } else if (item.objectType === 'operator') {
              textValue = `${textValue} ${item.shortText} `;
            }
            gridTitle += textValue;
          });
        }
      }

      return (
        <DraggableToolPaletteGrid
          key={gridEntry.id}
          gridEntry={gridEntry}
          index={index}
          gridType={gridType}
          getSelectedTargets={this.getSelectedTargets}
          handleBaseSelectionChange={
            this.state.crosstabStudy &&
            !this.state.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
              ? this.handleBaseSelectionChange
              : undefined
          }
          selectedOptions={this.state.selectedOptions}
          selectGridItem={this.selectGridItem}
          selectedPreviewItems={() =>
            this.state[gridType].filter(
              grid => this.state.selectedOptions[grid.id] >= 0
            )
          }
          renderToggleButton={
            this.state.crosstabStudy &&
            !this.state.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
              ? this.renderToggleButton
              : undefined
          }
          handleTargetDrop={this.handleTargetDrop}
          updateGridData={this.updateGridData}
          crosstabStudy={this.state.crosstabStudy.st}
          updateCrosstabTitleHeader={this.updateCrosstabTitleHeader}
          tooltipVal={gridTitle}
          toggleLabelFlag={toggleLabelFlag}
          crosstabViewFlag={
            gridType === 'ColumnsDataGrid' || gridType === 'RowsDataGrid'
          }
        />
      );
    });

  setToggleLabelFlag = (gridType, mode) => {
    this.props.crosstabActions.updateToggleLabelFlag(gridType);
    this.callSaveTrackerFn({
      action: CROSSTAB_FULL_SHORT_LABEL_TOOGLE_MODE,
      attributes: { gridType: gridType.toUpperCase(), toggleMode: mode },
    });
    sendVPVHotjarEvent(HJ_CROSSTAB_FULL_SHORT_LABEL_TOOGLE_MODE);
  };

  buildInfoBox = gridType => {
    const ibp = [];
    ibp.push(
      <ToggleLabel
        label={gridType}
        check={this.props.toggleCheckValue[gridType.toLowerCase()]}
        setToggleLabelFlag={this.setToggleLabelFlag}
      />
    );
    ibp.push(
      <InfoBoxSpacer Height="0.1em" boxClassName="toolPalette-spacer-row" />
    );
    // ibp.push(<InfoBoxSpacer toolPaletteInfoBox />);
    ibp.push(
      <GlobalDelete
        label={`Clear ${gridType}s`}
        deleteType="All"
        gridType={`${gridType}sDataGrid`}
        type={`${gridType.toLowerCase()}`}
        deleteAllOperation={this.deleteAllOperation}
      />
    );
    return ibp;
  };

  deleteAllOperation = (gridType, type) => {
    const crosstabTableList = this.props.crosstabTableList
      ? _.cloneDeep(this.props.crosstabTableList)
      : [];
    const updatedCrosstabRequestData = this.props.crosstabRequestData
      ? _.cloneDeep(this.props.crosstabRequestData)
      : [];
    const updatedCrosstabPayload = this.props.crosstabPayload
      ? _.cloneDeep(this.props.crosstabPayload)
      : [];
    if (crosstabTableList && crosstabTableList[0]) {
      this.callSaveTrackerFn({
        action: CROSSTAB_CLEAR_ALL_ITEMS,
        attributes: { gridType: type.toUpperCase() },
      });
      sendVPVHotjarEvent(HJ_CROSSTAB_CLEAR_ALL_ITEMS);
      if (type === 'row') {
        crosstabTableList[0].rowHeaderList = [];
        crosstabTableList[0].rowExpressionList = [];
        updatedCrosstabRequestData.rowHeaderList = [];
        updatedCrosstabRequestData.rowExpressionList = [];
        updatedCrosstabPayload &&
          updatedCrosstabPayload[0].crosstabList.forEach(elems => {
            elems.rowList = elems.rowList.filter(
              rowElems => rowElems.text === 'Total'
            );
          });

        const crosstabPerStudy = crosstabTableList[0].crosstabPerStudy;
        crosstabPerStudy &&
          crosstabPerStudy[0].forEach(elems => {
            elems.rowList = elems.rowList.filter(
              rowElems => rowElems.rowHeader === 'Total'
            );
          });
        crosstabTableList[0].crosstabPerStudy = crosstabPerStudy;
      } else {
        crosstabTableList[0].colHeaderList = [];
        crosstabTableList[0].colExpressionList = [];
        crosstabTableList[0].columnHeaderList = crosstabTableList[0].columnHeaderList.filter(
          column => column.label === 'Total'
        );
        updatedCrosstabRequestData.colHeaderList = [];
        updatedCrosstabRequestData.colExpressionList = [];
        updatedCrosstabPayload[0].headerList = [
          updatedCrosstabPayload[0].headerList[0],
        ];
        updatedCrosstabPayload &&
          updatedCrosstabPayload[0].crosstabList.forEach(elems => {
            elems.rowList.map(cellItem => {
              cellItem.cellList = [cellItem.cellList[0]];
            });
          });

        const crosstabPerStudy = crosstabTableList[0].crosstabPerStudy;
        crosstabPerStudy &&
          crosstabPerStudy[0].forEach(elems => {
            elems.rowList.forEach(row => {
              row.cellList = [row.cellList[0]];
            });
          });
        crosstabTableList[0].crosstabPerStudy = crosstabPerStudy;
      }
      this.props.crosstabActions.toggleCrosstabGridData(
        gridType,
        crosstabTableList,
        [],
        updatedCrosstabRequestData,
        updatedCrosstabPayload
      );
    } else {
      this.props.crosstabActions.toggleCrosstabGridData(gridType, [], []);
    }
  };



  closeSharedCrossTabModalFun = () => {
    this.shareCrossTabModal.hide();
  };

  openSharedCrosstabs = () => {
    this.props.crosstabActions.getSharedCrossTabList(
      this.props.loginResponse.data.userId
    );
    this.SharedCrossTabList.show();
    setTimeout(() => {
      this.afterOpenCrosstabModal.hide();
    }, 500);
  };

  closeSharedCrossTabList = () => {
    this.SharedCrossTabList.hide();
  };

  render() {
    return (
      <div className="width-20 minimize-tp float-left">
        <div>
          <Modal
            title="Shared Cross Tab"
            ref={node => (this.SharedCrossTabList = node)}
            dialogStyles={modalSavedCrosstabStyle}
          >
            <div>
              <SharedCrossTabList
                data={this.props.openSharedCrossTab}
                closeSharedCrossTabList={this.closeSharedCrossTabList}
              />
            </div>
          </Modal>
        </div>
        <ul className="accordion tool_bg">
          {!this.props.dataScreen && (
            <li className="accordion__item">
              <input
                type="checkbox"
                className="accordion__toggle"
                id="toggle-01"
              />
              <label
                className="accordion__trigger tool_img open_tool"
                htmlFor="toggle-01"
                title="Open"
              >
                Open
              </label>
              <div className="accordion__target padding-rl20">
                <button
                  type="button"
                  className="chart-type"
                  onClick={this.openCrosstabs}
                >
                  <p className="open" title="OPEN CROSSTAB">
                    open crosstab
                  </p>
                </button>
                <div className="chart-type">
                  <GenericFileUpload
                    id="spc-upload"
                    btnStyle="import"
                    handleUpload={this.handleImportSPC}
                    title="IMPORT .SPC"
                    btnDisabled={false}
                    name="import .spc"
                    trackerFn={this.importSPCHandler}
                    accept=".spc,.spc"
                  />
                </div>
              </div>
            </li>
          )}
          {!this.props.dataScreen && (
            <li className="accordion__item">
              <input
                type="checkbox"
                className="accordion__toggle"
                id="toggle-08"
              />
              <label
                className="accordion__trigger tool_img save_tool"
                htmlFor="toggle-08"
                title="Save"
              >
                Save
              </label>
              {CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND ===
              this.state.activeCrosstabTable.viewerGridType ? (
                <div className="accordion__target padding-rl20">
                  <div className="chart-type">
                    <button
                      className="save"
                      title="SAVE TREND"
                      onClick={this.handleSaveTrends}
                    >
                      Save trend
                    </button>
                  </div>
                </div>
              ) : (
                <div className="accordion__target padding-rl20">
                  <button
                    type="button"
                    className={`chart-type ${
                      (this.state.BasesDataGrid &&
                        this.state.BasesDataGrid.length > 0) ||
                      (this.state.ColumnsDataGrid &&
                        this.state.ColumnsDataGrid.length > 0) ||
                      (this.state.RowsDataGrid &&
                        this.state.RowsDataGrid.length > 0)
                        ? ''
                        : 'dataHaul-disabled'
                    }`}
                    disabled={
                      this.state.BasesDataGrid &&
                      this.state.BasesDataGrid.length <= 0 &&
                      this.state.ColumnsDataGrid &&
                      this.state.ColumnsDataGrid.length <= 0 &&
                      this.state.RowsDataGrid &&
                      this.state.RowsDataGrid.length <= 0
                    }
                    onClick={this.props.handleSaveCrosstab}
                  >
                    <p className="save" title="SAVE CROSSTAB">
                      Save crosstab
                    </p>
                  </button>
                </div>
              )}
            </li>
          )}
          {!this.props.dataScreen && (
            <li className="accordion__item">
              <input
                type="checkbox"
                className="accordion__toggle"
                id="toggle-09"
                onClick={this.props.shareCrosstab}
              />
              <label
                className="accordion__trigger tool_img share_tool"
                htmlFor="toggle-09"
                title="Share"
              >
                Share
              </label>
              <div className="accordion__target padding-rl20">
                  <div className="chart-type">
                    <span>Coming soon</span>
                  </div>
              </div>
            </li>
          )}
          {!this.props.dataScreen && (
            <li className="accordion__item">
              <input
                type="checkbox"
                className="accordion__toggle"
                id="toggle-07"
              />
              <label
                className="accordion__trigger tool_img export_tool"
                htmlFor="toggle-07"
                title="Export"
              >
                Export
              </label>
              <div className="accordion__target padding-rl20">
                {this.state.activeCrosstabTable.viewerGridType ===
                CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND ? (
                  <button
                    type="button"
                    className="chart-type"
                    onClick={() =>
                      this.setState(
                        { crosstabTitle: this.props.getCrosstabTitle() },
                        () => this.handleExportCrosstab('excel2007')
                      )
                    }
                  >
                    <p className="export_xls" title="EXPORT TREND">
                      export trend
                    </p>
                  </button>
                ) : (
                  <div>
                    <button
                      type="button"
                      className="chart-type"
                      onClick={
                        this.state.activeCrosstabTable.viewerGridType !==
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART &&
                        this.state.isExportEnabled
                          ? () =>
                              this.setState(
                                {
                                  crosstabTitle: this.props.getCrosstabTitle(),
                                },
                                () => this.handleExportCrosstab('excel2007')
                              )
                          : () => {}
                      }
                    >
                      <p
                        className="export_xls"
                        title="EXPORT .XLS"
                        style={
                          this.state.activeCrosstabTable.viewerGridType !==
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART
                            ? { cursor: 'pointer' }
                            : { cursor: 'text' }
                        }
                      >
                        export .xls
                      </p>
                    </button>
                    <button
                      type="button"
                      className="chart-type"
                      onClick={
                        this.state.activeCrosstabTable.viewerGridType !==
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART &&
                        this.state.isExportEnabled
                          ? () =>
                              this.setState(
                                {
                                  crosstabTitle: this.props.getCrosstabTitle(),
                                },
                                this.handleExportSPC
                              )
                          : () => {}
                      }
                    >
                      <p
                        className="export"
                        title="EXPORT .SPC"
                        style={
                          this.state.activeCrosstabTable.viewerGridType !==
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART
                            ? { cursor: 'pointer' }
                            : { cursor: 'text' }
                        }
                      >
                        export .spc
                      </p>
                    </button>
                    <button
                      type="button"
                      className="chart-type"
                      onClick={
                        this.state.activeCrosstabTable.viewerGridType !==
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART &&
                        this.state.isExportEnabled
                          ? () =>
                              this.setState(
                                {
                                  crosstabTitle: this.props.getCrosstabTitle(),
                                },
                                () => this.handleExportCrosstab('csv')
                              )
                          : () => {}
                      }
                    >
                      <p
                        className="export_spc"
                        title="EXPORT .CSV"
                        style={
                          this.state.activeCrosstabTable.viewerGridType !==
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART
                            ? { cursor: 'pointer' }
                            : { cursor: 'text' }
                        }
                      >
                        export .csv
                      </p>
                    </button>
                    {this.props.crosstabStudy &&
                      isStudyAccredited(this.props.crosstabStudy.sti) &&
                      (this.state.activeChartType ===
                        CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE ||
                        this.state.activeChartType ===
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.CROSSTAB) && (
                        <button
                          type="button"
                          className="chart-type"
                          onClick={
                            this.state.activeCrosstabTable.viewerGridType !==
                              CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE
                                .QUADCHART && this.state.isExportEnabled
                              ? () =>
                                  this.setState(
                                    {
                                      crosstabTitle: this.props.getCrosstabTitle(),
                                    },
                                    () => this.handleExportCrosstab('pdf')
                                  )
                              : () => {}
                          }
                        >
                          <p
                            className="export_pdf"
                            title="EXPORT .PDF"
                            style={
                              this.state.activeCrosstabTable.viewerGridType !==
                              CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART
                                ? { cursor: 'pointer' }
                                : { cursor: 'text' }
                            }
                          >
                            export .pdf
                          </p>
                        </button>
                      )}
                  </div>
                )}
              </div>
            </li>
          )}
          {!this.props.dataScreen && (
            <li className="accordion__item">
              <input
                type="checkbox"
                className="accordion__toggle"
                id="toggle-06"
              />
              <label
                className="accordion__trigger tool_img chart_tool"
                htmlFor="toggle-06"
                title="Chart Type"
              >
                Chart Type
              </label>
              <div className="accordion__target padding-rl20">
                <button
                  type="button"
                  className="chart-type"
                  onClick={() =>
                    this.handleGridSwitch(
                      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE
                    )
                  }
                >
                  <p
                    className={`private_eye ${this.getActiveClass(
                      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE
                    )}`}
                    title="PRIVATE EYE VIEW"
                  >
                    Private eye view
                  </p>
                </button>
                <button
                  type="button"
                  className="chart-type"
                  onClick={() => {
                    this.handleGridSwitch(
                      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.CROSSTAB
                    );
                  }}
                >
                  <p
                    className={`crosstab_view ${this.getActiveClass(
                      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.CROSSTAB
                    )}`}
                    title="CROSSTAB VIEW"
                  >
                    Crosstab view
                  </p>
                </button>
                <button
                  type="button"
                  className="chart-type"
                  onClick={() => {
                    this.handleGridSwitch(
                      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART
                    );
                  }}
                >
                  <p
                    className={`quad_chart_view ${this.getActiveClass(
                      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART
                    )} `}
                    title="QUAD CHART"
                  >
                    Quad chart
                  </p>
                </button>
                <div className="chart-type">
                  <p
                    className={`trend_view ${this.getActiveClass(
                      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND
                    )}`}
                    title={
                      this.isTrendButtonDisabled()
                        ? 'TREND'
                        : 'Trending is disabled for this study'
                    }
                    style={{
                      cursor: this.isTrendButtonDisabled()
                        ? 'pointer'
                        : 'default',
                    }}
                    onClick={() => {
                      if (this.isTrendButtonDisabled()) {
                        this.callSaveTrackerFn({ action: TOOL_CHART_TREND });
                        if (
                          this.props.trendStudies &&
                          this.props.trendStudies.length
                        ) {
                          this.handleGridSwitch(
                            CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND
                          );
                          return null;
                        }
                        this.trendModal.show();
                      }
                      return null;
                    }}
                  >
                    Trend
                    <img
                      src={EditIcon}
                      alt="Edit"
                      onClick={() => {
                        if (this.isTrendButtonDisabled())
                          this.trendModal.show();
                      }}
                    />
                  </p>
                </div>
                {this.state.showClusterCorrespondence && (
                  <button
                    disabled={_.isEmpty(this.props.activeCrosstabTable)}
                    className="chart-type corr-cluster-chart-type"
                    onClick={() => {
                      this.handleGridSwitch(
                        CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.CORR_CLUSTER
                      );
                    }}
                  >
                    <img
                      src={corrCluster}
                      title="CORRESPONDENCE & CLUSTER"
                      alt="Correspondece Icon"
                      className="curr_cluster_icon"
                    />
                    <p
                      className={
                        _.isEmpty(this.props.activeCrosstabTable) === true
                          ? 'cluster-disabled'
                          : 'cluster-active'
                      }
                      title="CORRESPONDENCE & CLUSTER"
                    >
                      Correspondence & Cluster
                    </p>
                  </button>
                )}
              </div>
            </li>
          )}
          {!this.props.dataScreen && (
            <li className="accordion__item">
              <input
                type="checkbox"
                className="accordion__toggle"
                id="toggle-05"
              />
              <label
                className="accordion__trigger tool_img metrics_tool"
                htmlFor="toggle-05"
                title="View"
              >
                View
              </label>
              <div className="accordion__target padding-rl20">
                <span
                  className="edit-clear"
                  onClick={() => this.clearSelected()}
                >
                  CLEAR ALL
                </span>
                {this.state.activeCrosstabTable.viewerGridType !== 'Quad' ? (
                  <GenericCheckboxesDropdown
                    dropdownTitle="Metrics"
                    handleCheckboxChange={this.handleMetricCheckboxesChange}
                    dropdownOptions={[
                      {
                        key: 'hnf',
                        name: 'HIGHLIGHT & FILTERING',
                        checked: this.state.checkBoxes.hnf,
                        visible:
                          this.state.activeCrosstabTable.viewerGridType !==
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND,
                        title: 'HIGHLIGHT & FILTERING',
                      },
                      {
                        key: 'sample',
                        name: 'SAMPLE',
                        checked: this.state.checkBoxes.sample,
                        visible: true,
                        // this.state.activeCrosstabTable.viewerGridType !==
                        // CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND,
                        title: 'SAMPLE',
                      },
                      {
                        key: 'weighted',
                        name: `WEIGHTED ${checkWeightType(
                          this.props.crosstabWeightTypes
                        )}`,
                        checked: this.state.checkBoxes.weighted,
                        visible: true,
                        // this.state.activeCrosstabTable.viewerGridType !==
                        // CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND,
                        title: `WEIGHTED ${checkWeightType(
                          this.props.crosstabWeightTypes
                        )}`,
                      },
                      {
                        key: 'vertical',
                        name: 'VERTICAL %',
                        checked: this.state.checkBoxes.vertical,
                        visible: true,
                        // this.state.activeCrosstabTable.viewerGridType !==
                        // CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND,
                        title: 'VERTICAL %',
                      },
                      {
                        key: 'horizontal',
                        name: 'HORIZONTAL %',
                        checked: this.state.checkBoxes.horizontal,
                        visible:
                          this.state.activeCrosstabTable.viewerGridType !==
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND,
                        title: 'HORIZONTAL %',
                      },
                      {
                        key: 'index',
                        name: 'INDEX',
                        checked: this.state.checkBoxes.index,
                        visible:
                          this.state.activeCrosstabTable.viewerGridType !==
                          CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND,
                        title: 'INDEX',
                      },
                    ]}
                  />
                ) : null}
              </div>
            </li>
          )}

          <li
            className={`accordion__item${
              this.props.isSmartSearchSelected ? '' : ' dataHaul-disabled'
            }`}
          >
            {this.props.isSmartSearchSelected && (
              <input
                type="checkbox"
                className="accordion__toggle"
                id="toggle-10"
                ref={node => (this.toggle10 = node)}
              />
            )}
            <label
              className="accordion__trigger tool_img grid_tool"
              htmlFor="toggle-10"
              title="Grid"
            >
              Grid
            </label>
            <div className="accordion__target">
              <ul className="marginl_5">
                {this.props.dataScreen !== DATAHAUL_CONSTANT && (
                  <li className="accordion__item">
                    <input
                      type="checkbox"
                      className="accordion__toggle"
                      id="toggle-02"
                      ref={node => (this.toggle2 = node)}
                    />
                    <DraggableToolPaletteHeader
                      renderLength={this.renderLength}
                      toggleNo="toggle-02"
                      title="BASES"
                      dataGridItems={this.state.BasesDataGrid}
                      standardBaseCount={
                        this.props.standardBaseLists
                          ? this.props.standardBaseLists.length
                          : 0
                      }
                      handleTargetDrop={this.handleTargetDrop}
                      gridType="BasesDataGrid"
                      icon="bases_tool"
                      study={
                        this.state.crosstabStudy
                          ? this.state.crosstabStudy.st
                          : undefined
                      }
                    />
                    <div className="accordion__target toolpalette-items">
                      <p
                        className="crosstab-recent-item-title"
                        onClick={
                          this.state.crosstabStudy &&
                          !this.state.crosstabStudy.st
                            .toLowerCase()
                            .includes(FLEX_STUDY_TAG)
                            ? () =>
                                this.handleBaseSelectionChange(
                                  CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS
                                    .Study_UNIVERSE
                                )
                            : () => {}
                        }
                      >
                        {this.state.crosstabStudy &&
                          !this.state.crosstabStudy.st
                            .toLowerCase()
                            .includes(FLEX_STUDY_TAG) && (
                            <DraggableToolPaletteGrid
                              isStudyUniverse
                              gridType="BasesDataGrid"
                              handleTargetDrop={this.handleTargetDrop}
                              crosstabStudy={this.state.crosstabStudy.st}
                              updateCrosstabTitleHeader={
                                this.updateCrosstabTitleHeader
                              }
                            />
                          )}
                      </p>
                      {this.state.crosstabStudy &&
                        !this.state.crosstabStudy.st
                          .toLowerCase()
                          .includes(FLEX_STUDY_TAG) &&
                        this.renderToggleButton(
                          CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS
                            .Study_UNIVERSE,
                          'BasesDataGrid'
                        )}

                      <div className="base-header">USER-DEFINED</div>

                      <div className="">
                        <span
                          className="clear-all"
                          onClick={() =>
                            this.props.crosstabActions.clearSampleWeighted(
                              'BasesDataGrid'
                            )
                          }
                        >
                          CLEAR ALL
                        </span>
                        <span
                          className={this.isEditButtonEnabled('BasesDataGrid')}
                          onClick={() => this.handleEditButton('BasesDataGrid')}
                        />
                        <span
                          className="delete-selected"
                          onClick={() => this.deleteSelected('BasesDataGrid')}
                        />
                      </div>

                      {this.renderRowsColumnsBases(
                        this.state.BasesDataGrid,
                        'BasesDataGrid'
                      )}
                      {this.showMoreItems(
                        this.state.BasesDataGrid,
                        'BasesDataGrid'
                      )}
                      {this.showMoreLabel(
                        this.state.BasesDataGrid,
                        'BasesDataGrid'
                      )}
                      {this.state.crosstabStudy &&
                      !this.props.loginResponse.data.universityUser &&
                      !this.state.crosstabStudy.st
                        .toLowerCase()
                        .includes(FLEX_STUDY_TAG) ? (
                        <div className="standard-base-header">
                          STANDARD
                          <img
                            className="standard_base_info_icon"
                            src={infoIconBlackOutline}
                            alt="Selection of predefined bases built by Simmons"
                            title="Selection of predefined bases built by Simmons"
                          />
                        </div>
                      ) : null}
                      {this.state.crosstabStudy &&
                      !this.props.loginResponse.data.universityUser &&
                      !this.state.crosstabStudy.st
                        .toLowerCase()
                        .includes(FLEX_STUDY_TAG)
                        ? this.props.standardBaseLists &&
                          this.showStandardBases(
                            this.props.standardBaseLists,
                            'StandardBases'
                          )
                        : null}
                      {this.state.crosstabStudy &&
                      !this.props.loginResponse.data.universityUser &&
                      !this.state.crosstabStudy.st
                        .toLowerCase()
                        .includes(FLEX_STUDY_TAG)
                        ? this.props.standardBaseLists &&
                          this.showMoreLabel(
                            this.props.standardBaseLists,
                            'StandardBases'
                          )
                        : null}
                    </div>
                  </li>
                )}
                {this.props.dataScreen === DATAHAUL_CONSTANT && (
                  <li className="accordion__item">
                    <input
                      type="checkbox"
                      className="accordion__toggle"
                      id="toggle-12"
                      ref={node => (this.toggle12 = node)}
                    />
                    <DraggableToolPaletteHeader
                      renderLength={this.renderLength}
                      toggleNo="toggle-12"
                      title="BASES"
                      dataGridItems={this.state.DataHaulBasesDataGrid}
                      handleTargetDrop={this.handleTargetDrop}
                      gridType="DataHaulBasesDataGrid"
                      icon="bases_tool"
                      study={
                        this.state.crosstabStudy
                          ? this.state.crosstabStudy.st
                          : undefined
                      }
                    />
                    <div className="accordion__target">
                      <div className="">
                        <span
                          className="clear-all"
                          onClick={() => {
                            this.props.crosstabActions.clearSampleWeighted(
                              'DataHaulBasesDataGrid'
                            );
                            this.callSaveTrackerFn({
                              action: TOOL_BASE_CLEAR_ALL,
                            });
                          }}
                        >
                          CLEAR ALL
                        </span>
                        <span
                          className={this.isEditButtonEnabled(
                            'DataHaulBasesDataGrid'
                          )}
                          onClick={() =>
                            this.handleEditButton('DataHaulBasesDataGrid')
                          }
                        />
                        <span
                          className="delete-selected"
                          onClick={() =>
                            this.deleteSelected('DataHaulBasesDataGrid')
                          }
                        />
                      </div>
                      <p
                        className="crosstab-recent-item-title"
                        onClick={
                          this.state.crosstabStudy &&
                          !this.state.crosstabStudy.st
                            .toLowerCase()
                            .includes(FLEX_STUDY_TAG)
                            ? () =>
                                this.handleBaseSelectionChange(
                                  CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS
                                    .Study_UNIVERSE
                                )
                            : () => {}
                        }
                      >
                        {this.state.crosstabStudy &&
                          !this.state.crosstabStudy.st
                            .toLowerCase()
                            .includes(FLEX_STUDY_TAG) && (
                            <DraggableToolPaletteGrid
                              isStudyUniverse
                              gridType="DataHaulBasesDataGrid"
                              handleTargetDrop={this.handleTargetDrop}
                              crosstabStudy={this.state.crosstabStudy.st}
                              updateCrosstabTitleHeader={
                                this.updateCrosstabTitleHeader
                              }
                              toggleLabelFlag
                            />
                          )}
                      </p>
                      {this.state.crosstabStudy &&
                        !this.state.crosstabStudy.st
                          .toLowerCase()
                          .includes(FLEX_STUDY_TAG) &&
                        this.renderToggleButton(
                          CrosstabUtils.DEFAULT_CROSSTAB_DATA_KEYS
                            .Study_UNIVERSE,
                          'DataHaulBasesDataGrid'
                        )}
                      {this.renderRowsColumnsBases(
                        this.state.DataHaulBasesDataGrid,
                        'DataHaulBasesDataGrid',
                        true
                      )}
                      {this.showMoreItems(
                        this.state.DataHaulBasesDataGrid,
                        'DataHaulBasesDataGrid',
                        true
                      )}
                      {this.showMoreLabel(
                        this.state.DataHaulBasesDataGrid,
                        'DataHaulBasesDataGrid'
                      )}
                    </div>
                  </li>
                )}
                {this.props.dataScreen !== DATAHAUL_CONSTANT && (
                  <li className="accordion__item">
                    <input
                      type="checkbox"
                      className="accordion__toggle"
                      id="toggle-03"
                      ref={node => (this.toggle3 = node)}
                    />
                    <ToolPaletteHeader
                      renderLength={this.renderLength}
                      toggleNo="toggle-03"
                      title="COLUMNS"
                      dataGridItems={this.state.ColumnsDataGrid}
                      handleTargetDrop={this.handleTargetDrop}
                      gridType="ColumnsDataGrid"
                      icon="columns_tool"
                      study={
                        this.state.crosstabStudy
                          ? this.state.crosstabStudy.st
                          : undefined
                      }
                    />
                    {this.props.crosstabColumns &&
                      this.props.crosstabColumns.length > 0 && (
                        <div className="accordion__target toolpalette-items">
                          <div className="toolPalette_items">
                            <span>
                              <InfoBox
                                Panels={this.buildInfoBox('Column')}
                                updatePanels={this.buildInfoBox}
                                Positions={['bottom']}
                                Align="end"
                                gridType="Column"
                                InfoBoxButtonInner={
                                  <img
                                    className="ibox-ellipsis"
                                    src={ToolPaletteEllipsisIcon}
                                    alt="..."
                                  />
                                }
                                containerClassName="toolPalette-popover-container"
                              />
                            </span>
                            <GlobalDelete
                              label="Delete"
                              deleteType="All"
                              gridType="ColumnsDataGrid"
                              type="column"
                              deleteAllOperation={this.deleteAllOperation}
                            />
                          </div>
                          <div className="toolPalette_label">
                            {this.props.toggleCheckValue.column
                              ? 'FULL COLUMN NAME'
                              : 'SHORT COLUMN NAME'}
                          </div>
                          {this.renderRowsColumnsBases(
                            this.state.ColumnsDataGrid,
                            'ColumnsDataGrid',
                            this.props.toggleCheckValue.column
                          )}
                          {this.showMoreItems(
                            this.state.ColumnsDataGrid,
                            'ColumnsDataGrid',
                            this.props.toggleCheckValue.column
                          )}
                          {this.showMoreLabel(
                            this.state.ColumnsDataGrid,
                            'ColumnsDataGrid'
                          )}
                        </div>
                      )}
                  </li>
                )}
                {this.props.dataScreen === DATAHAUL_CONSTANT && (
                  <li className="accordion__item">
                    <input
                      type="checkbox"
                      className="accordion__toggle"
                      id="toggle-13"
                      ref={node => (this.toggle13 = node)}
                    />
                    <DraggableToolPaletteHeader
                      renderLength={this.renderLength}
                      toggleNo="toggle-13"
                      title="COLUMNS"
                      dataGridItems={this.state.DataHaulColumnsDataGrid}
                      handleTargetDrop={this.handleTargetDrop}
                      gridType="DataHaulColumnsDataGrid"
                      icon="columns_tool"
                      study={
                        this.state.crosstabStudy
                          ? this.state.crosstabStudy.st
                          : undefined
                      }
                    />
                    <div className="accordion__target">
                      <div className="">
                        <span
                          className="clear-all"
                          onClick={() => {
                            this.props.crosstabActions.clearSampleWeighted(
                              'DataHaulColumnsDataGrid'
                            );
                            this.callSaveTrackerFn({
                              action: TOOL_COLUMN_CLEAR_ALL,
                            });
                          }}
                        >
                          CLEAR ALL
                        </span>
                        <span
                          className={this.isEditButtonEnabled(
                            'DataHaulColumnsDataGrid'
                          )}
                          onClick={() =>
                            this.handleEditButton('DataHaulColumnsDataGrid')
                          }
                        />
                        <span
                          className="delete-selected"
                          onClick={() =>
                            this.deleteSelected('DataHaulColumnsDataGrid')
                          }
                        />
                      </div>
                      {this.renderRowsColumnsBases(
                        this.state.DataHaulColumnsDataGrid,
                        'DataHaulColumnsDataGrid',
                        true
                      )}
                      {this.showMoreItems(
                        this.state.DataHaulColumnsDataGrid,
                        'DataHaulColumnsDataGrid',
                        true
                      )}
                      {this.showMoreLabel(
                        this.state.DataHaulColumnsDataGrid,
                        'DataHaulColumnsDataGrid'
                      )}
                    </div>
                  </li>
                )}
                {!this.props.dataScreen && (
                  <li className="accordion__item">
                    <input
                      type="checkbox"
                      className="accordion__toggle"
                      id="toggle-04"
                      ref={node => (this.toggle4 = node)}
                    />
                    <ToolPaletteHeader
                      renderLength={this.renderLength}
                      toggleNo="toggle-04"
                      title="ROWS"
                      dataGridItems={this.state.RowsDataGrid}
                      handleTargetDrop={this.handleTargetDrop}
                      gridType="RowsDataGrid"
                      icon="rows_tool"
                      study={
                        this.state.crosstabStudy
                          ? this.state.crosstabStudy.st
                          : undefined
                      }
                    />
                    {this.props.crosstabRows &&
                      this.props.crosstabRows.length > 0 && (
                        <div className="accordion__target toolpalette-items">
                          <div className="toolPalette_items">
                            <span className="">
                              <InfoBox
                                Panels={this.buildInfoBox('Row')}
                                updatePanels={this.buildInfoBox}
                                Positions={['bottom']}
                                Align="end"
                                gridType="Row"
                                InfoBoxButtonInner={
                                  <img
                                    className="ibox-ellipsis"
                                    src={ToolPaletteEllipsisIcon}
                                    alt="..."
                                  />
                                }
                                containerClassName="toolPalette-popover-container"
                              />
                            </span>
                            <GlobalDelete
                              label="Delete"
                              deleteType="All"
                              gridType="RowsDataGrid"
                              type="row"
                              deleteAllOperation={this.deleteAllOperation}
                            />
                          </div>
                          <div className="toolPalette_label">
                            {this.props.toggleCheckValue.row
                              ? 'FULL ROW NAME'
                              : 'SHORT ROW NAME'}
                          </div>
                          {this.renderRowsColumnsBases(
                            this.state.RowsDataGrid,
                            'RowsDataGrid',
                            this.props.toggleCheckValue.row
                          )}
                          {this.showMoreItems(
                            this.state.RowsDataGrid,
                            'RowsDataGrid',
                            this.props.toggleCheckValue.row
                          )}
                          {this.showMoreLabel(
                            this.state.RowsDataGrid,
                            'RowsDataGrid'
                          )}
                        </div>
                      )}
                  </li>
                )}
              </ul>
            </div>
          </li>
        </ul>
        <Modal
          title="Select Current Study"
          ref={node => (this.studyModal = node)}
          dialogStyles={modalStyle}
        >
          <StudySelector
            handleParentHide={() => this.studyModal.hide()}
            selectedStudy={this.state.crosstabStudy}
            selectedModule={this.props.dataScreen}
          />
        </Modal>
        <Modal
          title="Run Crosstab"
          ref={node => (this.afterOpenCrosstabModal = node)}
          dialogStyles={afterOpenCrosstabModalStyle}
        >
          <p>Please run the crosstab after loading.</p>
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => this.afterOpenCrosstabModal.hide()}
          />
        </Modal>
        <Modal
          title="Select Saved Crosstab"
          ref={node => (this.savedCrosstabsModal = node)}
          dialogStyles={modalSavedCrosstabStyle}
        >
          <div className="large-12 columns">
            <div>
              <SavedCrosstabs
                rowData={this.state.savedCrosstabs}
                closeLoadCrosstabModal={this.closeLoadCrosstabModal}
                updateCrosstabTitle={crosstabTitle =>
                  this.setState({ crosstabTitle })
                }
              />
            </div>
          </div>
        </Modal>
        <Modal
          title={`Trend Over Multiple Studies (${
            this.state.crosstabStudy && this.props.crosstabWeightTypes
              ? this.props.crosstabWeightTypes.wn
              : ''
          })`}
          ref={node => (this.trendModal = node)}
          dialogStyles={trendModalStyle}
        >
          <div className="row expanded">
            <TrendMultiSelect
              handleParentHide={() => this.trendModal.hide()}
              runCrosstab={this.props.runCrosstab}
              setChartType={() =>
                this.setState({
                  activeChartType:
                    CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND,
                })
              }
              columnsDataGrid={this.state.ColumnsDataGrid}
              rowsDataGrid={this.state.RowsDataGrid}
            />
          </div>
        </Modal>
        <Modal
          title="Cell Highlighting and Filtering"
          ref={node => (this.toolpaletteHiglights = node)}
          dialogStyles={ModalQuadChartorHnFStyle}
        >
          <Highlight
            tableData={this.state.activeCrosstabTable}
            handleHighlightAndFilter={this.handleHighlightAndFilter}
            handleConditionalFiltering={this.handleConditionalFiltering}
            handleParentHide={() => this.toolpaletteHiglights.hide()}
            handleRadioOptions={this.handleRadioOptions}
          />
        </Modal>
        <Modal
          title=""
          ref={node => (this.warningQuadModal = node)}
          dialogStyles={modalQuadWariningStyle}
        >
          <div className="text-center">
            <p>
              Please add at least 2 columns and click run to see Quad Chart.
            </p>
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-125px"
              onBtnClick={() => this.warningQuadModal.hide()}
            />
          </div>
        </Modal>
        <Modal
          title="Select Bases to Export"
          ref={node => (this.exportBaseModal = node)}
          dialogStyles={trendModalStyle}
        >
          <div className="row expanded">
            <ExportBaseMultiSelect
              handleParentHide={() => this.exportBaseModal.hide()}
              basesDataGrid={this.state.BasesDataGrid}
              standardBaseLists={this.props.standardBaseLists}
              userPreference={this.props.userPreference}
              getItemType={this.getItemType}
              handleExportBasePopupBaseClick={
                this.handleExportBasePopupBaseClick
              }
            />
          </div>
        </Modal>
      </div>
    );
  }
}

ToolPalette.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
  bases: PropTypes.arrayOf(PropTypes.object),
  savedCrosstabs: PropTypes.arrayOf(PropTypes.object),
  studies: PropTypes.arrayOf(PropTypes.object),
  trendStudies: PropTypes.arrayOf(PropTypes.object),
  crosstabTableList: PropTypes.arrayOf(PropTypes.object),
  standardBaseLists: PropTypes.arrayOf(PropTypes.object),
  crosstabStudy: PropTypes.shape({
    pn: PropTypes.number,
    wt: PropTypes.number,
    dv: PropTypes.number,
    sti: PropTypes.number,
  }),
  crosstabBaseList: PropTypes.shape({
    baseList: PropTypes.arrayOf(PropTypes.string),
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
      universityUser: PropTypes.bool,
    }),
  }),
  crosstabActions: PropTypes.shape({
    updateCrosstabGrid: PropTypes.func,
    updateSampleWeighted: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
    showSavedCrosstabs: PropTypes.func,
    exportCrosstab: PropTypes.func,
    importSPC: PropTypes.func,
    deleteCrosstabGrid: PropTypes.func,
    clearSampleWeightedKPIs: PropTypes.func,
    setSelectedBase: PropTypes.func,
    setActiveCrosstabTable: PropTypes.func,
    addDDNHCSData: PropTypes.func,
    updateCrosstabTitleHeader: PropTypes.func,
    fetchStandardBaseList: PropTypes.func,
    getSampleWeighted: PropTypes.func,
    exportBaseSelectionList: PropTypes.func,
    updateCrosstabTitleList: PropTypes.func,
    toggleCrosstabGridData: PropTypes.func,
    updateToggleLabelFlag: PropTypes.func,
    importNewSPC: PropTypes.func,
    getDictionaryDataDetails: PropTypes.func,
  }),
  crosstabBases: PropTypes.arrayOf(PropTypes.object),
  quickReportsActions: PropTypes.shape({
    clearSampleWeightedKPIs: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    dictionaryTargetReset: PropTypes.func,
    clearTreeLoadNodeList: PropTypes.func,
    setDataPointAlreadyAdded: PropTypes.func,
  }),
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
    clearTrendStudies: PropTypes.func,
  }),
  activeAccountId: PropTypes.number,
  handleMetricsChange: PropTypes.func,
  handleCrosstabEdit: PropTypes.func,
  getCrosstabTitle: PropTypes.func,
  dataScreen: PropTypes.string,
  resetSmarchSearch: PropTypes.func,
  handleSaveCrosstab: PropTypes.func,
  isSmartSearchSelected: PropTypes.bool,
  runCrosstab: PropTypes.func,
  cbCrossTabViewTypeChanged: PropTypes.func,
  resetHighlightFilterState: PropTypes.func,
  resetTitle: PropTypes.func,
  activeCrosstabTable: PropTypes.shape({
    conditionalFormatting: PropTypes.string,
    highlightAndFilter: PropTypes.shape({}),
  }),
  DataHaulBases: PropTypes.arrayOf({}),
  DataHaulColumns: PropTypes.arrayOf({}),
  selectedBase: PropTypes.string,
  selectedBaseNode: PropTypes.string,
  selectedBaseGroup: PropTypes.string,
  shareCrosstab: PropTypes.func,
  crosstabTitleHeaderList: PropTypes.shape({}),
  exportBaseSelectionList: PropTypes.shape({}),
  userPreference: PropTypes.shape({}),
  crosstabWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
    wn: PropTypes.string,
  }),
  toolPaletteSavedName: PropTypes.string,
  permissions: PropTypes.arrayOf(PropTypes.number),
  enableCorrespondence: PropTypes.func,
  allFeatures: PropTypes.bool,
  partsToShow: PropTypes.shape({}),
  DictionaryDetails: PropTypes.shape({}),
  loadNewSPCCrosstabData: PropTypes.shape({
    id: PropTypes.number,
    products: PropTypes.shape([]),
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    permissions: state.userDetail.permissions,
    activeAccountId: state.account.activeAccountId,
    crosstabStudy: state.study.crosstabStudy,
    trendStudies: state.study.trendStudies,
    savedCrosstabs: state.crosstab.savedCrosstabs,
    crosstabTableList: state.crosstab.crosstabTableList,
    crosstabBaseList: state.crosstab.crosstabBaseList,
    studies: state.study.studies,
    selectedBase: state.selectedBase.selectedBase,
    selectedBaseNode: state.selectedBase.selectedBaseNode,
    selectedBaseGroup: state.selectedBase.selectedBaseGroup,
    activeCrosstabTable: state.crosstab.activeCrosstabTable,
    crosstabBases: state.crosstab.BasesDataGridData,
    crosstabColumns: state.crosstab.ColumnsDataGridData,
    crosstabRows: state.crosstab.RowsDataGridData,
    standardBaseLists: state.crosstab.standardBaseLists,
    userPreference: state.preferences.userPreferences[PREFERENCE_CROSSTAB],
    crosstabTitleHeaderList: state.crosstab.crosstabTitleHeaderList,
    exportBaseSelectionList: state.crosstab.exportBaseSelectionList,
    crosstabWeightTypes: state.study.crosstabWeightTypes,
    toggleCheckValue: state.crosstab.toggleCheckValue,
    crosstabRequestData: state.crosstab.crosstabRequestData,
    crosstabPayload: state.crosstab.crosstabPayload,
    openSharedCrossTab: state.crosstab.openSharedCrossTab,
    allFeatures: state.userDetail.allFeatures,
    partsToShow: state.crosstab.partsToShow,
    DictionaryDetails: state.crosstab.DictionaryDetails,
    loadNewSPCCrosstabData: state.crosstab.loadNewSPCCrosstabData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(ToolPalette);
